
(function () {
    'use strict';
    angular.module('tmx-app').controller('loanApplicationEditCtrl', ['$scope', '$rootScope', '$timeout', '$http', 'dynamicFormService', 'lookupService', 'resolvedData', 'LoanApplicationService', 'tmxUtility', '$state', "$stateParams", 'ToastService', 'BroadcastService', "$mdDialog", "tmxResource", "cacheStore", "$window", "TMX_FINANCE_CONSTANTS", "TmxDialogService", "$filter",
        function loanApplicationEditCtrl($scope, $rootScope, $timeout, $http, dynamicFormService, lookupService, resolvedData, LoanApplicationService, tmxUtility, $state, $stateParams, ToastService, BroadcastService, $mdDialog, tmxResource, cacheStore, $window, TMX_FINANCE_CONSTANTS, TmxDialogService, $filter) {

            //#region  ========== Variables Declaration=============================
            var vm = this;
            var exists;
            var copy;
            var STATUS = {
                NEW: "New",
                UNKNOWN: "Unknown",
                DRAFT: "Draft"
            };
            var TenantsList = TMX_FINANCE_CONSTANTS.TENANTS;
            var SlsFrmuEligibilityParams = {};
            vm.tmxResource = tmxResource;
            vm.id = $stateParams.Id;
            vm.istabDisabled = false;
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
            var objectToArray = new Set();
            var rootKeys = [];
            var objectToIterage = [];
            var objectKeys = [];
            var keyThatAreActuallyObject = ["TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson", "TmxCustomerMaster[0].TmxECIBDetail[0].TmxeCIBDetailHistoryMap"];
            var vitasTenants = [TenantsList.VITAS, TenantsList.VITAS_EG, TenantsList.VITAS_LEB, TenantsList.VITAS_IRQ];
            var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;
            vm.statuses = lookupService.getLocalLookupsByType(lkupType.APPLICATION_STATUS);
            var BVS_PRODUCT_CHECKLIST_ID = null;
            vm.isPageLoading = false;
            vm.slsUpdated = false;
            vm.checklistUpdated = false;
            vm.ecibUpdated = false;
            vm.silkECIBUpdated = false;
            vm.reloadDocuments = false;
            vm.showCommentDialog = showCommentDialog;
            vm.showManualDeviationDialog = showManualDeviationDialog;
            vm.showEvaluationRulesDialog = showEvaluationRulesDialog;
            vm.applicationStatus = "UnKnown";
            vm.status = "Unknwon";
            vm.showEMIButton = false;
            vm.showTranslationButton = false;
            vm.showValidateButton = false;
            vm.showCreditButton = false;
            vm.showAccountButton = false;
            vm.showtransferInWallet = false;
            vm.disableL2Button = false;
            vm.showDisbursementButton = false;
            vm.hideValidateButton = false;
            vm.checkPermission = tmxUtility.checkPermission;
            vm.dynamicFormService = dynamicFormService;
            vm.errorType = 'dynamic';// two types of errors, dynamic: that resolve dynamically. static: that do not resolve dynmically. They stay on screen until submission.
            vm.bizRulesFailedFields = [];//none of the fields have biz rule violations at begining            
            vm.showEcibButton = false;
            vm.showActionsButton = false;
            vm.checklistSaved = false;
            vm.resetPermission = vm.checkPermission('Loan Application Reset Button');
            vm.savePermission = vm.checkPermission('Loan Application Save Button');
            vm.showDownloadButton = true;

            vm.actionButtons = {
                "EvaluateRule": false,
                "CalculateEmi": false,
                "TranslateValues": false,
                "CalculateFee": false,
                "GenerateOTP": false,
                "VerifyOTP": false,
                "ValidateEntity": false,
                "CreditReport": false,
                "CalculateDbr": false,
                "CreditApproval": false,
                "LoanDisbursement": false,
                "TransferInWallet": false,
                "OpenL2Account": false,
                "CHECKELIGIBILITY": false,
                "DataCheck": false,
                "ShoweCIB": false,
                "ViewNewCNICeCIB": false,
                " ViewOldCNICeCIB": false,
            };

            function setupActionButtons() {
                vm.actionButtons['EvaluateRule'] = vm.checkPermission('EvaluateRule', 'View');
                vm.actionButtons['CalculateEmi'] = vm.showEMIButton && vm.showFunctionalButton();
                vm.actionButtons['TranslateValues'] = vm.showTranslationButton && vm.showFunctionalButton();
                vm.actionButtons['CalculateFee'] = vm.checkPermission('Service Fee', 'View') && vm.showFunctionalButton();
                vm.actionButtons['GenerateOTP'] = vm.checkPermission('Generate OTP', 'View') && vm.showFunctionalButton()
                vm.actionButtons['VerifyOTP'] = vm.checkPermission('Verify OTP', 'View') && vm.showFunctionalButton();
                vm.actionButtons['ValidateEntity'] = vm.checkPermission('Validate Service', 'View') && vm.showFunctionalButton() && !vm.hideValidateButton;
                vm.actionButtons['CreditReport'] = vm.checkPermission('Credit Report Button', 'View') && vm.showFunctionalButton();
                vm.actionButtons['CalculateDbr'] = vm.checkPermission('CalculateDBR', 'View') && vm.showFunctionalButton()
                vm.actionButtons['CreditApproval'] = vm.checkPermission('Credit Approval', 'View');
                vm.actionButtons['LoanDisbursement'] = vm.checkPermission('Loan Disbursement', 'View');
                vm.actionButtons['TransferInWallet'] = vm.checkPermission('Transfer In Wallet', 'View');
                vm.actionButtons['OpenL2Account'] = vm.checkPermission('L2 Account Opening', 'View');
                vm.actionButtons['CHECKELIGIBILITY'] = vm.checkPermission('CheckEligibility', 'View') && vm.showFunctionalButton()
                vm.actionButtons['DataCheck'] = vm.checkPermission('Data Check', 'View')
                vm.actionButtons['ShoweCIB'] = vm.showEcibButton && vm.checkPermission('Show ECIB', 'View');
                vm.actionButtons['ViewNewCNICeCIB'] = vm.checkPermission('Show ECIB', 'View') && !vm.showEcibButton;
                vm.actionButtons['ViewOldCNICeCIB'] = vm.checkPermission('Show ECIB', 'View') && !vm.showEcibButton;

                vm.showActionsButton = vm.showActionButton = Object.keys(vm.actionButtons).some(key => vm.actionButtons[key] == true);
            }

            vm.errorControl = {
                watch: true,//switch to start watching(updates dynamically)
                show: true,//switch to show errors (red red kerdy ga har jagah :3)
                enable: true,//gloabl switch to turn on and of validation checkings
                validations: {//object to operate each validation individually
                    required: true,//only for new loan app and draft loan app, required checking must be disabled
                    maxlength: true,
                    minlength: true
                }
            };
            vm.peripherals = {
                mustFields: [],//fields that must be filled irresepective of state of loan app
                locals: {
                    getBranchIdOfUser: function () {
                        if (resolvedData.informationIconData) {
                            return resolvedData.informationIconData.data.CompanyBranchId;
                        }
                        else {
                            return resolvedData.responseData.loanApplicationData.data.CompanyBranchId;
                        }
                    }
                }
            }

            var LoggedInTenant, tenantName = "";
            var DATA_CHECK_LOAN_PRODUCT_CHECKLIST_ID = null;
            var VERIFICATION_STATE_ROLE = null;
            var LoggedInUserConfigurations = cacheStore.get("Configurations");
            vm.fillManadtory = true;
            vm.errorControl.validations.required = !vm.fillManadtory;
            var culture = localStorage.getItem('culture');
            var ecibAttachPdf, ecibProductChecklistId, ecibAttachmentURL;
            var productId = resolvedData.responseData.loanApplicationData.data.LoanProductId;
            //#endregion


            //#region  ============== Private functions=====================================
            function readConfigurations() {
                if (LoggedInUserConfigurations) {
                    LoggedInTenant = LoggedInUserConfigurations.filter(function (item) {
                        return item.ConfigurationKey == 'INTEGRATION_TENANT';
                    })[0];

                    DATA_CHECK_LOAN_PRODUCT_CHECKLIST_ID = LoggedInUserConfigurations.filter(function (item) {
                        return item.ConfigurationKey == 'DATA_CHECK_LOAN_PRODUCT_CHECKLIST_ID';
                    })[0];

                    VERIFICATION_STATE_ROLE = LoggedInUserConfigurations.filter(function (item) {
                        return item.ConfigurationKey == 'VERIFICATION_STATE_ROLE';
                    })[0];

                    vm.useTemplatePdf = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'USE_TEMPLATE_PDF', true);
                    vm.isCommentMandatory = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'IS_SUBMISSION_COMMENT_MANDATORY', true);
                }
                tenantName = LoggedInTenant.ConfigurationValue ? LoggedInTenant.ConfigurationValue.toLowerCase() : "";
                BVS_PRODUCT_CHECKLIST_ID = LoggedInUserConfigurations.filter(function (item) {
                    return item.ConfigurationKey == 'BVS_PRODUCT_CHECKLIST_ID';
                })[0];

                
                ecibAttachPdf = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'ECIB_PDF_TO_ATTACH', true, productId) == true;
                ecibProductChecklistId = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'ECIB_PDF_PRODUCT_CHECKLIST_ID', true, productId);
            }

            function findPersonIncomeDetailIndex(lkpId, TmxPersonIncomeDetail) {
                var IndexValue = 0;
                TmxPersonIncomeDetail.forEach(function (item, index) {
                    if (item.IncomeSourceLkp == lkpId) {
                        IndexValue = index;
                    }
                })
                return IndexValue;
            }

            function updateResource() {

                var ResourcePersonIncomeDetail = vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail;
                var DfPersonIncodeDetail = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail;

                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonFirstName = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonFirstName;
                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth;
                vm.resource.TmxCustomerMaster[0].NationalIdentifierValue = dynamicFormService.applicationData.TmxCustomerMaster[0].NationalIdentifierValue;
                vm.resource.TmxCustomerMaster[0].OldNationalIdentifierValue = dynamicFormService.applicationData.TmxCustomerMaster[0].OldNationalIdentifierValue;


                vm.resource.TmxCustomerMaster[0].CurCityUDF = dynamicFormService.applicationData.TmxCustomerMaster[0].CurCityUDF;
                vm.resource.TmxCustomerMaster[0].CurAddressLine3UDF = dynamicFormService.applicationData.TmxCustomerMaster[0].CurAddressLine3UDF;
                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonCurrentAddress = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonCurrentAddress;
                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.AddressLine2 = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.AddressLine2;
                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.AddressLine3 = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.AddressLine3;
                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.Criteria = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.Criteria;
                if (vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                    vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                }
                if (dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                    dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                }
                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].SegmentLkp = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].SegmentLkp;
                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].ProfessionTypeLkp = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].ProfessionTypeLkp;
                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer;
                if (vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail.length == 0) {
                    vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail;
                }
                else {
                    var SrcLkp1 = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail[findPersonIncomeDetailIndex(1, DfPersonIncodeDetail)].MonthlyIncomeAmount;
                    var SrcLkp4 = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail[findPersonIncomeDetailIndex(4, DfPersonIncodeDetail)].MonthlyIncomeAmount;
                    vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail[findPersonIncomeDetailIndex(1, ResourcePersonIncomeDetail)].MonthlyIncomeAmount = parseFloat(SrcLkp1);
                    vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail[findPersonIncomeDetailIndex(4, ResourcePersonIncomeDetail)].MonthlyIncomeAmount = parseFloat(SrcLkp4);
                }
                if (vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson) {
                    vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonTotalIncomeAmount = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonTotalIncomeAmount;
                }
            }
            vm.canvasCreation = function () {
                let div = document.getElementById('verifiedCustomerData');
                vm.isPageLoading = true;
                html2canvas(div).then(
                    function (canvas) {
                        //vm.isPageLoading = true;
                        $scope.URL = canvas.toDataURL("image/png");
                        $scope.dataURL = $scope.URL.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
                        vm.checklistSaved = true;
                        var BVSCheckObj = dynamicFormService.applicationData.TmxLoanApplicationChecklist.filter(function (item) {
                            return item.LoanProductChecklistId == BVS_PRODUCT_CHECKLIST_ID.ConfigurationValue
                        })[0];

                        if (!BVSCheckObj)
                            BVSCheckObj = {};
                        BVSCheckObj.MimeType = "image/png";
                        BVSCheckObj.Attachment = $scope.URL;
                        BVSCheckObj.AttachmentURL = $scope.dataURL;
                        if (dynamicFormService.applicationData.TmxLoanApplicationChecklist && dynamicFormService.applicationData.TmxLoanApplicationChecklist.length > 0 && BVSCheckObj) {
                            var id = dynamicFormService.applicationData.TmxLoanApplicationChecklist.findIndex(p => p.LoanProductChecklistId == BVS_PRODUCT_CHECKLIST_ID.ConfigurationValue);
                            dynamicFormService.applicationData.TmxLoanApplicationChecklist[id] = BVSCheckObj;
                        }
                        else {
                            dynamicFormService.applicationData.TmxLoanApplicationChecklist = [];
                            dynamicFormService.applicationData.TmxLoanApplicationChecklist.push(BVSCheckObj);
                        }
                        if (dynamicFormService.applicationData.TmxLoanApplicationChecklist && dynamicFormService.applicationData.TmxLoanApplicationChecklist.length > 0) {
                            var bvsid = dynamicFormService.applicationData.TmxLoanApplicationChecklist.findIndex(p => p.LoanProductChecklistId == BVS_PRODUCT_CHECKLIST_ID.ConfigurationValue);
                            if (vm.resource.TmxLoanApplicationChecklist && vm.resource.TmxLoanApplicationChecklist.length > 0)
                                var rsrcid = vm.resource.TmxLoanApplicationChecklist.findIndex(p => p.LoanProductChecklistId == BVS_PRODUCT_CHECKLIST_ID.ConfigurationValue);
                            if (rsrcid >= 0) {
                                vm.resource.TmxLoanApplicationChecklist[rsrcid].MimeType = "image/png";
                                vm.resource.TmxLoanApplicationChecklist[rsrcid].Attachment = dynamicFormService.applicationData.TmxLoanApplicationChecklist[bvsid].Attachment;
                                vm.resource.TmxLoanApplicationChecklist[rsrcid].AttachmentURL = dynamicFormService.applicationData.TmxLoanApplicationChecklist[bvsid].AttachmentURL;

                            }
                            else {
                                vm.resource.TmxLoanApplicationChecklist.push(dynamicFormService.applicationData.TmxLoanApplicationChecklist[bvsid]);
                            }
                        }
                        vm.isPageLoading = false;
                        ToastService.showCustomToast('success', 'Screenshot Taken');
                        return;

                    });
            }
            function updateResourceCopyChecklist() {
                if (vm.resource.TmxLoanApplicationChecklist && vm.resource.TmxLoanApplicationChecklist.length > 0) {
                    var bvsid = vm.resource.TmxLoanApplicationChecklist.findIndex(p => p.LoanProductChecklistId == BVS_PRODUCT_CHECKLIST_ID.ConfigurationValue);
                    if (vm.ResourceCopy.TmxLoanApplicationChecklist && vm.ResourceCopy.TmxLoanApplicationChecklist.length > 0)
                        var rsrcid = vm.ResourceCopy.TmxLoanApplicationChecklist.findIndex(p => p.LoanProductChecklistId == BVS_PRODUCT_CHECKLIST_ID.ConfigurationValue);
                    if (rsrcid >= 0) {
                        vm.ResourceCopy.TmxLoanApplicationChecklist[rsrcid].MimeType = vm.resource.TmxLoanApplicationChecklist[bvsid].MimeType;
                        vm.ResourceCopy.TmxLoanApplicationChecklist[rsrcid].Attachment = vm.resource.TmxLoanApplicationChecklist[bvsid].Attachment;
                        vm.ResourceCopy.TmxLoanApplicationChecklist[rsrcid].AttachmentURL = vm.resource.TmxLoanApplicationChecklist[bvsid].AttachmentURL;

                    }
                    else {
                        vm.ResourceCopy.TmxLoanApplicationChecklist.push(vm.resource.TmxLoanApplicationChecklist[bvsid]);
                    }
                }
            }
            function updateResourceCopy() {

                if (dynamicFormService.applicationData && dynamicFormService.applicationData.TmxCustomerMaster && dynamicFormService.applicationData.TmxCustomerMaster[0]) {
                    var ResourcePersonIncomeDetail = vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail;
                    var DfPersonIncodeDetail = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail;

                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonFirstName = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonFirstName;
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth;
                    vm.ResourceCopy.TmxCustomerMaster[0].NationalIdentifierValue = dynamicFormService.applicationData.TmxCustomerMaster[0].NationalIdentifierValue;
                    vm.ResourceCopy.TmxCustomerMaster[0].OldNationalIdentifierValue = dynamicFormService.applicationData.TmxCustomerMaster[0].OldNationalIdentifierValue;
                    vm.ResourceCopy.TmxCustomerMaster[0].NationalIdTypeLkp = dynamicFormService.applicationData.TmxCustomerMaster[0].NationalIdTypeLkp;
                    vm.ResourceCopy.TmxCustomerMaster[0].negarea = dynamicFormService.applicationData.TmxCustomerMaster[0].negarea;
                    vm.ResourceCopy.TmxCustomerMaster[0].negcustomer = dynamicFormService.applicationData.TmxCustomerMaster[0].negcustomer;
                    vm.ResourceCopy.TmxCustomerMaster[0].FRMUStatus = dynamicFormService.applicationData.TmxCustomerMaster[0].FRMUStatus;
                    vm.ResourceCopy.TmxCustomerMaster[0].SLSStatus = dynamicFormService.applicationData.TmxCustomerMaster[0].SLSStatus;
                    vm.ResourceCopy.TmxCustomerMaster[0].EcibFetchFlag = dynamicFormService.applicationData.TmxCustomerMaster[0].EcibFetchFlag;


                    vm.ResourceCopy.TmxCustomerMaster[0].CurCityUDF = dynamicFormService.applicationData.TmxCustomerMaster[0].CurCityUDF;
                    vm.ResourceCopy.TmxCustomerMaster[0].CurAddressLine3UDF = dynamicFormService.applicationData.TmxCustomerMaster[0].CurAddressLine3UDF;

                    if (dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail && dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0] && dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson) {
                        vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonCurrentAddress = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonCurrentAddress;
                        vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.AddressLine2 = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.AddressLine2;
                        vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.AddressLine3 = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.AddressLine3;


                        if (vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                            vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                        }
                        if (dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                            dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                        }
                        vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].SegmentLkp = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].SegmentLkp;
                        vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].ProfessionTypeLkp = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].ProfessionTypeLkp;
                        vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer;
                        vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness;
                        if (vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail.length == 0) {
                            vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail;
                        }
                        else {
                            var SrcLkp1 = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail[findPersonIncomeDetailIndex(1, DfPersonIncodeDetail)].MonthlyIncomeAmount;
                            var SrcLkp4 = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail[findPersonIncomeDetailIndex(4, DfPersonIncodeDetail)].MonthlyIncomeAmount;
                            vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail[findPersonIncomeDetailIndex(1, ResourcePersonIncomeDetail)].MonthlyIncomeAmount = parseFloat(SrcLkp1);
                            vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail[findPersonIncomeDetailIndex(4, ResourcePersonIncomeDetail)].MonthlyIncomeAmount = parseFloat(SrcLkp4);
                        }
                        if (vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson) {
                            vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonTotalIncomeAmount = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonTotalIncomeAmount;
                        }
                    }

                }
            }

            function updateSlsFrmuEligibilityParams() {

                SlsFrmuEligibilityParams.loanAppId = dynamicFormService.applicationData.LoanApplicationId;
                SlsFrmuEligibilityParams.DOB = vm.formatDateOfBirth(dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth);
                SlsFrmuEligibilityParams.ADDRESS = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonCurrentAddress;
                SlsFrmuEligibilityParams.NAME = dynamicFormService.applicationData.TmxCustomerMaster[0].CustomerName;
                SlsFrmuEligibilityParams.CNIC = dynamicFormService.applicationData.TmxCustomerMaster[0].NationalIdentifierValue;
                SlsFrmuEligibilityParams.OldCNIC = dynamicFormService.applicationData.TmxCustomerMaster[0].OldNationalIdentifierValue;

                if (dynamicFormService.applicationData.TmxCustomerMaster[0].CurAddressLine3UDF) {
                    var AreaCode = lookupService.getLookupById(dynamicFormService.applicationData.TmxCustomerMaster[0].CurAddressLine3UDF);
                    SlsFrmuEligibilityParams.AreaCode = AreaCode.VisibleValue;
                }

                if (dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail.length == 0) {
                    SlsFrmuEligibilityParams.MonthlyIncomeAmount = 0;
                    SlsFrmuEligibilityParams.GrossIncomeAmount = 0;
                }
                else {
                    var SrcLkp1 = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail[findPersonIncomeDetailIndex(1, dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonIncomeDetail)].MonthlyIncomeAmount;
                    SlsFrmuEligibilityParams.MonthlyIncomeAmount = parseFloat(SrcLkp1);
                    SlsFrmuEligibilityParams.GrossIncomeAmount = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonTotalIncomeAmount;
                }

                if (dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                    dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                }
                SlsFrmuEligibilityParams.SegmentLkp = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].SegmentLkp;
                SlsFrmuEligibilityParams.ProfessionTypeLkp = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].ProfessionTypeLkp;
                SlsFrmuEligibilityParams.NatureOfBusiness = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness;
                SlsFrmuEligibilityParams.CompanyName = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer;
                SlsFrmuEligibilityParams.Criteria = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.Criteria;
            }

            function checkSLS() {

                vm.isPageLoading = true;
                if (!SlsFrmuEligibilityParams.CompanyName) {
                    vm.isPageLoading = false;
                    ToastService.showCustomToast('error', 'Please Enter Company Name')
                    return;
                }
                tmxResource('Integration').getByAction('SLS', false, 'post', SlsFrmuEligibilityParams).then(function (response) {
                    vm.isPageLoading = false;
                    vm.resource.TmxCustomerMaster[0].SlsFlag = 1;
                    if (response.data.sls_status == 'Cleared') {
                        vm.resource.TmxCustomerMaster[0].SLSStatus = response.data.sls_status;
                        checkFRMU();
                    }
                    else {
                        vm.resource.TmxCustomerMaster[0].SLSStatus = null;
                        vm.resource.TmxCustomerMaster[0].FRMUStatus = null;
                        vm.resource.TmxCustomerMaster[0].negcustomer = false;
                        vm.resource.TmxCustomerMaster[0].negarea = false;

                        if (vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                            vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                        }
                        vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = "";
                        SlsFrmuEligibilityParams.NatureOfBusiness = "";

                        dynamicFormService.applicationData = vm.resource;
                        loadData(vm.resource, true);
                        $scope.$broadcast("reloadSlsAndFrmuData", {});
                        ToastService.showCustomToast('error', 'SLS: ' + response.data.description);

                    }
                });
            }

            function checkFRMU() {
                vm.isPageLoading = true;
                if (!(SlsFrmuEligibilityParams.CNIC && SlsFrmuEligibilityParams.CompanyName && SlsFrmuEligibilityParams.AreaCode)) {
                    vm.isPageLoading = false;
                    ToastService.showCustomToast('error', 'Please Enter Required Fields.')
                    return;
                }

                tmxResource('Integration').getByAction('FRMU', false, 'post', SlsFrmuEligibilityParams).then(function (response) {
                    vm.isPageLoading = false;
                    //loadData(vm.resource,true);
                    mapCleanObjects(vm.resource, vm.loanApplicationData);

                    if (response.data.code == "00") {
                        var LookupByTypeAndHiddenValue = lookupService.getLookupByTypeAndHiddenValue(lkupType.COMPANY_SEGMENT, response.data.category);
                        if (LookupByTypeAndHiddenValue && LookupByTypeAndHiddenValue.length) {
                            response.data.category = LookupByTypeAndHiddenValue[0].LookupId;
                        }
                        if (response.data.approved_company != "") {
                            vm.resource.TmxCustomerMaster[0].FRMUStatus = "Cleared";
                            vm.resource.cleared = true;
                            vm.resource.blackListed = false;
                            vm.resource.NatureOfBusiness = response.data.category;
                            SlsFrmuEligibilityParams.NatureOfBusiness = response.data.category;
                            if (vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                            }
                            vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = response.data.category;
                        }
                        else if (response.data.approved_company == "") {
                            vm.resource.TmxCustomerMaster[0].FRMUStatus = null;
                            vm.resource.cleared = false;
                            vm.resource.blackListed = false;
                            vm.resource.NatureOfBusiness = response.data.category;
                            SlsFrmuEligibilityParams.NatureOfBusiness = response.data.category;
                            if (vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                            }
                            vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = response.data.category;
                        }
                        if (response.data.frmu != "") {
                            vm.resource.TmxCustomerMaster[0].FRMUStatus = "Black Listed";
                            vm.resource.cleared = false;
                            vm.resource.blackListed = true;
                        }
                        else if (response.data.frmu == "" && response.data.approved_company == "") {
                            vm.resource.TmxCustomerMaster[0].FRMUStatus = null;
                            vm.resource.cleared = false;
                            vm.resource.blackListed = false;
                        }
                        if (response.data.neg_cust != "") {
                            vm.resource.TmxCustomerMaster[0].negcustomer = true;
                        }
                        else if (response.data.neg_cust == "") {
                            vm.resource.TmxCustomerMaster[0].negcustomer = false;
                        }

                        if (response.data.neg_area != "") {
                            vm.resource.TmxCustomerMaster[0].negarea = true;
                        }
                        else if (response.data.neg_area == "") {
                            vm.resource.TmxCustomerMaster[0].negarea = false;
                        }
                        vm.resource.TmxCustomerMaster[0].CurAddressLine3UDF = dynamicFormService.applicationData.TmxCustomerMaster[0].CurAddressLine3UDF;
                        vm.resource.TmxCustomerMaster[0].NationalIdentifierValue = SlsFrmuEligibilityParams.CNIC;

                        if (vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                            vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                        }
                        vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer = SlsFrmuEligibilityParams.CompanyName;

                        dynamicFormService.applicationData = vm.resource;
                        loadData(vm.resource, true);
                        $scope.$broadcast("reloadSlsAndFrmuData", {});

                        vm.isPageLoading = false;
                        if (!SlsFrmuEligibilityParams.CNIC) {

                            ToastService.showCustomToast('error', 'Please Enter CNIC In SLS & FRMU tab for fetching ECIB.');
                            return;
                        }
                        else {
                            if ((response.data.approved_company == '')) {
                                ToastService.showCustomToast('error', 'FRMU: Negative Company');
                            }
                            else if (response.data.neg_cust != "") {
                                ToastService.showCustomToast('error', 'FRMU: Negative Customer');
                            }


                            else if (!(exists(SlsFrmuEligibilityParams.CompanyName) &&
                                exists(SlsFrmuEligibilityParams.MonthlyIncomeAmount) &&
                                SlsFrmuEligibilityParams.MonthlyIncomeAmount > 0 &&
                                exists(SlsFrmuEligibilityParams.GrossIncomeAmount) &&
                                SlsFrmuEligibilityParams.GrossIncomeAmount > 0 &&
                                exists(SlsFrmuEligibilityParams.SegmentLkp) &&
                                exists(SlsFrmuEligibilityParams.ProfessionTypeLkp) &&
                                exists(SlsFrmuEligibilityParams.NatureOfBusiness) &&
                                exists(SlsFrmuEligibilityParams.loanAppId) &&
                                exists(SlsFrmuEligibilityParams.DOB) &&
                                SlsFrmuEligibilityParams.DOB != 'N/A' &&
                                exists(SlsFrmuEligibilityParams.NAME) &&
                                exists(SlsFrmuEligibilityParams.CNIC) &&
                                exists(SlsFrmuEligibilityParams.AreaCode))) {
                                ToastService.showCustomToast('error', 'Missing Fields For Checking Eligibility');
                            }

                            else {
                                getECIB();
                            }
                        }
                    }
                    else if (response.data.code == "01" && response.data.description && response.data.description.toLowerCase().includes('no record')) {

                        if (!exists(SlsFrmuEligibilityParams.NatureOfBusiness)) {
                            ToastService.showCustomToast('error', 'Please Select Company Segment');
                            return;
                        }

                        if (response.data.neg_cust != "") {
                            vm.resource.TmxCustomerMaster[0].negcustomer = true;
                        }
                        else if (response.data.neg_cust == "") {
                            vm.resource.TmxCustomerMaster[0].negcustomer = false;
                        }

                        if (response.data.neg_area != "") {
                            vm.resource.TmxCustomerMaster[0].negarea = true;
                        }
                        else if (response.data.neg_area == "") {
                            vm.resource.TmxCustomerMaster[0].negarea = false;
                        }
                        if (response.data.frmu == "" && response.data.approved_company == "") {
                            vm.resource.TmxCustomerMaster[0].FRMUStatus = null;
                            vm.resource.cleared = false;
                            vm.resource.blackListed = false;
                        }
                        vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = SlsFrmuEligibilityParams.NatureOfBusiness;

                        getECIB();
                    }
                    else {
                        vm.resource.TmxCustomerMaster[0].FRMUStatus = null;
                        vm.resource.TmxCustomerMaster[0].negcustomer = false;
                        vm.resource.TmxCustomerMaster[0].negarea = false;

                        if (vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.length == 0) {
                            vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail.push({});
                        }
                        vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = "";
                        dynamicFormService.applicationData = vm.resource;
                        loadData(vm.resource, true);
                        $scope.$broadcast("reloadSlsAndFrmuData", {});
                        ToastService.showCustomToast('error', 'FRMU: ' + response.data.description);
                    }
                });
            }


            function getECIB() {
                vm.isPageLoading = true;
                if (!SlsFrmuEligibilityParams.CNIC) {
                    vm.isPageLoading = false;
                    ToastService.showCustomToast('error', 'Please Enter CNIC In SLS & FRMU tab.')
                    return;
                }

                dynamicFormService.applicationData = vm.resource;
                //loadData(vm.resource);
                vm.save(function () {
                    LoanApplicationService.getEligibility(SlsFrmuEligibilityParams).then(function (response) {
                        if (exists(response.data, 'LoanApplicationId')) {
                            var tmxResource = vm.tmxResource('LoanApplication');
                            vm.resource = tmxResource.createResourceObject(response.data);
                            vm.resource.TmxCustomerMaster[0].EcibFetchFlag = 1;
                            dynamicFormService.applicationData = vm.resource;
                            loadData(vm.resource, true);
                            $scope.$broadcast("reloadSlsAndFrmuData", {});
                            callDBR();
                        }
                        vm.isPageLoading = false;

                    });
                });
            }

            function callDBR() {
                vm.isPageLoading = true;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, false);
                formatJsonForPost();

                tmxResource("LoanApplication").getByAction("AggregateDBR", false, 'put', vm.ResourceCopy).then(function (response) {
                    if (response.status.code == 200 || response.status.code == 201) {
                        vm.resource = response.data;
                    }
                    vm.loanApplicationData = angular.copy(vm.resource);
                    dynamicFormService.applicationData = vm.resource;
                    loadData(vm.resource);
                    $scope.$broadcast("reloadSlsAndFrmuData", {});
                    vm.isPageLoading = false;
                });
            }

            function removeUnwantedTabs(responseLoanApplicationData, tfs) {
                var loggedInUserRoleName = JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).roles[Object.keys(JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).roles)[0]].name.toLowerCase();
                if (VERIFICATION_STATE_ROLE && loggedInUserRoleName == VERIFICATION_STATE_ROLE.ConfigurationValue.toLowerCase()) {
                    var allowedTabsList = [];
                    var loggedInUserId = JSON.parse(localStorage.getItem("user")).Id;
                    allowedTabsList = responseLoanApplicationData.TmxLoanApplicationChecklist.map(item => item.TabID).filter((value, index) => responseLoanApplicationData.TmxLoanApplicationChecklist[index].UserID == loggedInUserId);
                    tfs.Tabs = tfs.Tabs.filter(function (item) {
                        return allowedTabsList.indexOf(item.TabId) > -1
                    });
                }
            }

            function loadData(responseLoanApplicationData, skipPageSchemaReload) {
                objectToArray = new Set();
               
                if (TenantsList.UBANK == tenantName) {
                    var currentApplicationStatus = vm.statuses.find(function (item) { return item.LookupId == responseLoanApplicationData.ApplicationStatusLkp });
                    var lookupValue;
                    if (exists(currentApplicationStatus)) {
                        lookupValue = currentApplicationStatus.VisibleValue;
                    }
                    if(!(lookupValue == "Approve" || lookupValue == "Reject")){
                        var lookupArrayCollateralNew;
                        lookupArrayCollateralNew = lookupService.getLocalLookupsByType(lkupType.COLLATERALS_RATE);
                        var newCollateralPrice = lookupArrayCollateralNew.filter(item =>
                            item.ParentLookupId == responseLoanApplicationData.TmxCustomerMaster[0]?.ShroffBranchCodeUdf
                        );
                        if(newCollateralPrice){
                            if(responseLoanApplicationData.TmxCustomerMaster[0]?.GramPriceUdfH){
                                responseLoanApplicationData.TmxCustomerMaster[0].GramPriceUdfH = newCollateralPrice.HiddenValue;
                                responseLoanApplicationData.TmxCustomerMaster[0].GramPriceUdf = newCollateralPrice.HiddenValue;
                            }
                        }
                    }
                }
               
                var selectedTab = exists(vm.page, "selectedTab") ? vm.page.selectedTab : undefined;
                if (exists(resolvedData, "responseData.pageSchema.data")) {
                    vm.pageSchema = resolvedData.responseData.pageSchema.data;
                    tfsManipulation(vm.pageSchema[0]);
                    dynamicFormService.pageSchema = vm.pageSchema[0]; // To access raw schema in dynamic page
                    var status = null;
                    if (exists(responseLoanApplicationData) && exists(responseLoanApplicationData)) {
                        vm.applicationStatus = vm.statuses.find(function (item) { return item.LookupId == responseLoanApplicationData.ApplicationStatusLkp });
                        if (exists(status)) {
                            vm.applicationStatus = status.VisibleValue;
                        }
                    }
                    if (!skipPageSchemaReload) {
                        removeUnwantedTabs(responseLoanApplicationData, vm.pageSchema[0]);
                        vm.page = dynamicFormService.loadPage(vm.pageSchema[0], undefined, vm.errorControl, vm.peripherals);//load page from schema
                        vm.page.registerDependants();
                    }
                    if (exists(selectedTab) && selectedTab > 0) {
                        vm.page.selectedTabIndex = vm.page.tabs.findIndex(tab => tab.id == selectedTab);

                        if (vm.page.selectedTabIndex == 0) { // chosoy: 0th tab was appearing collapsed
                            $timeout(function () {
                                vm.page.tabs[vm.page.selectedTabIndex].isSelected = true;
                                vm.page.selectedTab = selectedTab;
                            });
                        }
                        else { // No timeout in this section to avoid glitch
                            vm.page.tabs[vm.page.selectedTabIndex].isSelected = true;
                            vm.page.selectedTab = selectedTab;
                        }
                    }
                    vm.page.fieldMap.all.forEach(function (field) { initQuestion(field, resolvedData.questions) });
                    if (vm.page.tabs.filter(function (tab) { return tab.title == 'Loan Checklist' }).length) {
                        vm.page.tabs.filter(function (tab) { return tab.title == 'Loan Checklist' })[0].config.cols = 2;//loan checklist must be 2 column layout
                    }

                    vm.page.tabs.filter(function (tab) { return tab.title == 'FATCA Form' || tab.title == 'Credit Score' }).forEach(function (tab) { tab.config.cols = 1; });

                    var applicationDate = null;
                    if (vm.page.fieldMap.tname['TmxLoanApplication']) {
                        applicationDate = vm.page.fieldMap.tname['TmxLoanApplication']['LoanApplicationDate'];
                    }

                    if (exists(applicationDate) && !exists(applicationDate.value)) {
                        applicationDate.updateValue((new Date), vm.page.fieldMap.primaryKey);
                    }

                    if (exists(resolvedData, "responseData.loanApplicationData.data")) {
                        if (exists(resolvedData, "informationIconData.data")) {//Information Icon fixes
                            copy(resolvedData.informationIconData.data, [], responseLoanApplicationData);
                            responseLoanApplicationData.TmxCompanyBranch = { BranchName: resolvedData.informationIconData.data.BranchName };
                        }
                        vm.loanApplicationData = responseLoanApplicationData;
                        wrapLoanApplicationAttributes(vm.loanApplicationData);

                        var loanProduct = [];
                        if (vm.page.fieldMap.tname['TmxLoanApplication']) {
                            loanProduct = vm.page.fieldMap.tname['TmxLoanApplication']['LoanProductId'];
                        }

                        if (exists(loanProduct)) {
                            if (loanProduct.otherValues) {
                                loanProduct.otherValues.push({
                                    name: "getServiceChargesFromProduct",
                                    decription: "get services charges for current product",
                                    func: function () {
                                        var product = vm.loanApplicationData.TmxProduct ? vm.loanApplicationData.TmxProduct : resolvedData.loanProduct;
                                        loanProduct.getServiceChargesFromProduct = product;
                                    }
                                });
                            }
                        }

                        if (vm.loanApplicationData["TmxCustomerMaster"]) {
                            takeOutChild(vm.loanApplicationData, vm.loanApplicationData.TmxCustomerMaster, 'TmxCustomerMaster');
                            makeObjectToArray(vm.loanApplicationData)
                            vm.page.read(vm.loanApplicationData, vm.page.fieldMap);// fill the page object with initial loan application data
                            vm.commands = vm.loanApplicationData.Commands;
                            vm.commandList = copy(vm.commands); //Vm.Commands is will be used on screen. VM.Commandlist will be maintained internally for controlled deviation. 
                            if (exists(vm.commands)) {
                                vm.commands = vm.commands.filter(x => x.IsDeviation != 1); //Dont show commands with IsDeviation on screen
                                vm.commands.forEach(function (command) {
                                    command.label = formatName(command.VisibleValue);
                                });//format commands if any
                            }
                        }
                        else {
                            vm.loanApplicationData = new LoanApplicationService();
                        }
                    }
                }
            }

            function setDataAndState() {
                if (resolvedData.responseData && resolvedData.responseData.loanApplicationData && resolvedData.responseData.loanApplicationData.data) {
                    loadData(resolvedData.responseData.loanApplicationData.data);
                }


                if (exists($stateParams.callbackState)) {//page to return to when leaving this screen
                    vm.returnState = $stateParams.callbackState;
                }
                else {
                    vm.returnState = "^";//if nothing specified, move to parent state
                }

                vm.resource = copy(vm.loanApplicationData);//vm.resource is the object we send to server for saving
                dynamicFormService.applicationData = vm.resource;
            }


            function dataCheckResponseCallBack() {
                vm.isPageLoading = true;
                var action = "ResolvePM";
                (function () {

                    var data = {
                        "FileNumber": vm.fileNumber,
                        "TransactionNumber": vm.transactionNumber,
                        "CustomerMasterId": vm.ResourceCopy.TmxCustomerMaster[0].CustomerMasterId
                    }
                    tmxResource("Enquiry").getByAction(action, false, 'post', data).then(function (response) {
                        if (response != null && response.data != null && response.data.url != null) {
                            $window.open(response.data.url, "_blank");
                            var url = response.data.url;
                            var dataCheckObj = vm.resource.TmxLoanApplicationChecklist.filter(function (item) {
                                return item.LoanProductChecklistId == DATA_CHECK_LOAN_PRODUCT_CHECKLIST_ID.ConfigurationValue
                            })

                            if (dataCheckObj.length == 0) {
                                dataCheckObj.push({
                                    LoanProductChecklistId: DATA_CHECK_LOAN_PRODUCT_CHECKLIST_ID.ConfigurationValue
                                })
                            }
                            dataCheckObj[0].MimeType = "text/html";
                            dataCheckObj[0].Attachment = url;
                            dataCheckObj[0].AttachmentURL = url;
                            vm.isPageLoading = true;
                            loadData(vm.resource);
                            vm.isPageLoading = false;
                        }
                        else
                            vm.isPageLoading = false;
                    });
                })();
            }

            vm.downloadPDF = function () {
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.page.write(vm.ResourceCopy, false);
                unwrapLoanApplicationAttributes(vm.ResourceCopy);
                vm.bindRootObjectsToChildObjects();
                makeArrayToObject(vm.ResourceCopy);
                vm.deleteEmptyObjects();
                objectCleaning(vm.ResourceCopy);
                setLoanApplicationChecklist();

                var templates = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.LOAN_APP_PDF_TYPES);
                var templateToDownload = { templateName: 'Loan_Application_HTML', pdfName: 'Loan Application.pdf' };
                if (exists(templates) && templates.length > 0) // Go in this case to set templates if there are value in lookups else use default values as defined above
                {
                    if (templates.length == 1) {
                        templateToDownload = {
                            templateName: templates[0].HiddenValue,
                            pdfName: templates[0].VisibleValue.endsWith('.pdf') ? templates[0].VisibleValue : templates[0].VisibleValue + '.pdf'
                        }
                    }
                    else {
                        showTemplateSelectionDialog(templates, function (selectedTemplate) {
                            if (!exists(selectedTemplate)) {
                                return;
                            }
                            templateToDownload = {
                                templateName: selectedTemplate.HiddenValue,
                                pdfName: selectedTemplate.VisibleValue.endsWith('.pdf') ? templates[0].VisibleValue : selectedTemplate.VisibleValue + '.pdf'
                            };
                            $http.put(APP_CONSTANTS.backend + 'LoanApplication/DownloadLoanApplicationPDF/' + templateToDownload.templateName, vm.ResourceCopy, { responseType: 'arraybuffer' }).success(function (data) {
                                var file = new Blob([data], { type: 'application/pdf' });
                                saveOrDownloadPDF(file, templateToDownload.pdfName);
                            });
                        }, function () { });

                        return; /// return from original function
                    }
                }

                $http.put(APP_CONSTANTS.backend + 'LoanApplication/DownloadLoanApplicationPDF/' + templateToDownload.templateName, vm.ResourceCopy, { responseType: 'arraybuffer' }).success(function (data) {
                    var file = new Blob([data], { type: 'application/pdf' });
                    saveOrDownloadPDF(file, templateToDownload.pdfName);
                });
            }

            function saveOrDownloadPDF(file, pdfName) {
                var openPdfInNewTab = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'OPEN_PDF_WINDOW', true) || false;
                if (openPdfInNewTab) {
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL)
                }
                else {
                    saveAs(file, pdfName);
                }

            }

            function showTemplateSelectionDialog(data, successcb, errorcb) {
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', 'data', TemplateSelectionDialogCtrl],
                    templateUrl: 'app/private/transaction/pdf-template-selection-dialog.html',
                    parent: angular.element(document.body),
                    locals: {
                        data: data
                    },
                    clickOutsideToClose: true,
                    fullscreen: true,
                })
                    .then(function (templateObj) {
                        successcb(templateObj)
                    }, function () {
                        errorcb();
                    });
            }

            function TemplateSelectionDialogCtrl($scope, $mdDialog, data) {
                $scope.templateLookups = data;
                $scope.selectedTemplateId = null;
                var selectedTemplate = $scope.templateLookups[0];
                $scope.done = function () {
                    if ($scope.selectedTemplateId != null && $scope.selectedTemplateId != undefined) {
                        selectedTemplate = $scope.templateLookups.find(x => x.LookupId == $scope.selectedTemplateId);
                        $mdDialog.hide(selectedTemplate);
                    }
                }
                $scope.cancel = function () {
                    $mdDialog.hide();
                }
            }

            function showEvaluationRulesDialog(evaluationData, showOnlyMessages) {
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', '$filter', 'evaluationData', 'lookupService', 'UsersService', 'showOnlyMessages', 'tenantName', 'TenantsList', EvaluationRulesDialogController],
                    locals: { evaluationData: evaluationData, showOnlyMessages: showOnlyMessages, tenantName: tenantName, TenantsList: TenantsList },
                    templateUrl: 'app/private/transaction/loan-application/edit/evaluation-rule-dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                    .then(function (responseData) {

                        if (responseData) {
                            vm.isPageLoading = true;
                            var ProcessInstanceID = vm.loanApplicationData.ProcessInstanceID;
                            var action = "ExecuteWf";
                            (function () {
                                var data = {
                                    "Parameter": '',
                                    "Command": 'DeviationApproval',
                                    "TargetUserId": responseData.TargetUserId,
                                    "rule": evaluationData.data,
                                    "UserId": JSON.parse(localStorage.getItem("user")).Id,
                                    "ProcessID": ProcessInstanceID,
                                    "ApplicationId": vm.loanApplicationData.LoanApplicationId,
                                    "TmxLoanApplicationRemark": responseData.TmxLoanApplicationRemark
                                }
                                LoanApplicationService.getByAction(action, true, "put", data).then(function () {
                                    vm.isPageLoading = false;
                                    $state.go("private.inbox");
                                });
                            })();
                        }
                    }, function () {

                    });
            }

            function showControlledDeviaitonDialog(deviationData) {
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', '$filter', 'lookupService', 'UsersService','tmxUtility', 'deviationData', 'commandList', ControlledDeviationDialogContoller],
                    locals: { deviationData: deviationData, commandList: vm.commandList },
                    templateUrl: 'app/private/transaction/loan-application/edit/controlled-deviation-dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                    .then(function (responseData) {

                        if (responseData) {
                            vm.isPageLoading = true;
                            var ProcessInstanceID = vm.loanApplicationData.ProcessInstanceID;
                            var action = "ExecuteWf";
                            (function () {
                                var data = {
                                    "Parameter": '',
                                    "Command": responseData.commandName,
                                    "TargetUserId": responseData.targetUserId,
                                    "rule": deviationData.data,
                                    "UserId": JSON.parse(localStorage.getItem("user")).Id,
                                    "ProcessID": ProcessInstanceID,
                                    "ApplicationId": vm.loanApplicationData.LoanApplicationId,
                                    "TmxLoanApplicationRemark": responseData.TmxLoanApplicationRemark,
                                    "TmxWorkflowReceivingActor": responseData.TmxWorkflowReceivingActor
                                }
                                LoanApplicationService.getByAction(action, true, "put", data).then(function () {
                                    vm.isPageLoading = false;
                                    $state.go("private.inbox");
                                });
                            })();
                        }
                    }, function () {

                    });
            }

            function showManualDeviationDialog(command, ParameterName, ev) {
                var loggedInUserId = JSON.parse(localStorage.getItem("user")).Id;
                var LoanApplicationID = vm.loanApplicationData.LoanApplicationId;
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', '$filter', 'lookupService', 'UsersService', ManualDeviationDialogController],
                    templateUrl: 'app/private/transaction/loan-application/edit/manual-deviation-dialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen, // Only for -xs, -sm breakpoints.
                    locals: { ApplicationId: LoanApplicationID, UserId: loggedInUserId },
                })
                    .then(function () {
                        vm.isPageLoading = true;
                        var ProcessInstanceID = vm.loanApplicationData.ProcessInstanceID;
                        var action = "ExecuteWf";
                        vm.save(function () {

                            var data = {
                                "Parameter": ParameterName,
                                "Command": command,
                                "ProcessID": ProcessInstanceID,
                                "ApplicationId": LoanApplicationID,
                                "UserId": loggedInUserId,
                            }
                            vm.isPageLoading = true;
                            LoanApplicationService.getByAction(action, true, "put", data).then(function (response) {
                                vm.isPageLoading = false;
                                if (response.data.status) {
                                    if (response.data.status.code < 400) {
                                        $state.go("private.inbox");
                                    }
                                    else {
                                        showEvaluationRulesDialog(response.data.data);
                                    }
                                }

                            });
                        });


                    }, function () {

                    });
            }

            function showCommentDialog(commandObj, ev) {
                let command = commandObj.HiddenValue;
                let ParameterName = commandObj.ParameterName;
                let receivingActors = commandObj.TmxWorkflowReceivingActor;
                let loanChecklists = vm.loanApplicationData.TmxLoanApplicationChecklist.filter(p => p.VerificationRequired == 1 && p.UserID == null);
                var LoanApplicationID = vm.loanApplicationData.LoanApplicationId;
                var ProcessInstanceID = vm.loanApplicationData.ProcessInstanceID;
                var loggedInUserId = JSON.parse(localStorage.getItem("user")).Id;
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', '$filter', 'TMX_FINANCE_CONSTANTS', 'tmxUtility', 'UsersService', 'lookupService', 'ToastService', 'command', 'Parameter', 'Actors', 'Checklists', 'ProcessID', 'ApplicationId', 'UserId', 'TenantName', CommentsDialogController],
                    locals: { command: command, Parameter: ParameterName, Actors: receivingActors, Checklists: loanChecklists, ProcessID: ProcessInstanceID, ApplicationId: LoanApplicationID, UserId: loggedInUserId, TenantName: tenantName },
                    templateUrl: 'app/private/transaction/loan-application/edit/comment-dialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                }).then(function (responseData) {
                    vm.isPageLoading = true;
                    vm.save(function () {
                        ExecuteWorkflow(responseData);
                    });

                }, function () {

                });

                function ExecuteWorkflow(responseData, forcedFlag) {

                    if (vm.saveSuccess >= 400) {
                        vm.isPageLoading = false;
                        return;
                    }

                    var action = "ExecuteWf";
                    var data = {
                        "Parameter": ParameterName,
                        "Command": command,
                        "ProcessID": ProcessInstanceID,
                        "ApplicationId": LoanApplicationID,
                        "UserId": loggedInUserId,
                        "TmxLoanApplicationRemark": responseData.TmxLoanApplicationRemark,
                        "TmxWorkflowReceivingActor": responseData.TmxWorkflowReceivingActor,
                        "TmxSmartAdvance": vm.loanApplicationData.TmxSmartAdvance,
                        "ForcedFlag": forcedFlag
                    }
                    LoanApplicationService.getByAction(action, false, "put", data).then(function (response) {
                        vm.isPageLoading = false;
                        if (response.data && response.data != null) {

                            if (response.data.status && response.data.status.code == 417) {
                                let validationText = "";
                                if (exists(response.data.data) && exists(response.data.data.Errors) && response.data.data.Errors.length > 0) {
                                    response.data.data.Errors.forEach(function (val) {
                                        validationText += val + "<br>";
                                    });
                                }
                                vm.showSimpleDialog("Validation Rules", validationText);

                                if (response.data.data.model) {
                                    var tmxResource = vm.tmxResource('LoanApplication');
                                    vm.resource = tmxResource.createResourceObject(response.data.data.model);
                                    vm.loanApplicationData = angular.copy(vm.resource);
                                    dynamicFormService.applicationData = vm.resource;
                                    loadData(vm.resource, false);  //temporary fix for grid binding issue
                                }

                            }
                            else if (response.data.manualDeviation || exists(response.data.data, 'manualDeviation')) {
                                if (!exists(response.data.manualDeviation)) { // In some cases deviations is coming inside data so handling that case
                                    response.data.manualDeviation = response.data.data.manualDeviation;
                                }
                                showDeviationDialog(response);
                            }
                            else if (response.status.code!=200 && (response.data.controlledDeviation || exists(response.data.data, 'controlledDeviation'))) {
                                let deviationText = "Following deviations occurred on the application: <br>";
                                if (!exists(response.data.controlledDeviation)) { // In some cases deviations is coming inside data so handling that case
                                    response.data.controlledDeviation = response.data.data.controlledDeviation;
                                    response.data.controlledDeviation.forEach(function (val, idx) {
                                        deviationText += (idx + 1) + '-' + val + "<br>";
                                    });

                                    deviationText += "<br>Do you want to proceed with deviation?"
                                }
                                if (response.data.data.model) {
                                    let tmxResource = vm.tmxResource('LoanApplication');
                                    vm.resource = tmxResource.createResourceObject(response.data.data.model);
                                    vm.loanApplicationData = angular.copy(vm.resource);
                                    dynamicFormService.applicationData = vm.resource;
                                    loadData(vm.resource, false);  //temporary fix for grid binding issue
                                }
                                TmxDialogService.showConfirmDialog("Deviation Rules", deviationText,
                                    function () {
                                        showControlledDeviaitonDialog(response.data);
                                    }, function () { // When NO is selected then forcefully skip deviation
                                        ExecuteWorkflow(responseData, true);
                                    }
                                );
                                console.log(response.data.controlledDeviation);

                            }
                            else if (response.data.error || exists(response.data.data, 'error')) {
                                if (!exists(response.data.error)) { // In some cases error is coming inside data so handling that case
                                    response.data.error = response.data.data.error;
                                }
                                loadData(vm.resource, false); //temporary fix for grid binding issue
                                showDeviationDialog(response);
                            }
                            else if (response.data.warning || exists(response.data.data, 'warning')) {
                                if (!exists(response.data.warning)) { // In some cases warning is coming inside data so handling that case
                                    response.data.warning = response.data.data.warning;
                                }
                                showDeviationDialog(response);
                            }
                            else if (exists(response.data.wFDeviation) || exists(response.data.data, 'wFDeviation')) {
                                if (!exists(response.data.wFDeviation)) { // In some cases wf deviations is coming inside data so handling that case
                                    response.data.wFDeviation = response.data.data.wFDeviation;
                                }
                                let validationText = "";
                                if (exists(response.data.wFDeviation) && response.data.wFDeviation.length > 0) {
                                    response.data.wFDeviation.forEach(function (val, index) {
                                        validationText += index + 1 + ') ' + val + "<br>";
                                    });
                                }
                                vm.showSimpleDialog("WorkFlow Deviation(s)", validationText, function () {
                                    $state.go("private.inbox");
                                });
                            }
                            else {
                                $state.go("private.inbox");
                            }
                        }
                        else {
                            $state.go("private.inbox");
                        }
                    });
                }

                function showDeviationDialog(response) {
                    if (response.data && !exists(response.data.data)) {
                        var data = response.data;
                        response.data = {};
                        response.data.data = {};
                        response.data.data = data;
                    }
                    showEvaluationRulesDialog(response.data.data);
                    dynamicFormService.applicationData = vm.resource;
                    vm.errorControl.validations.required = false;
                    loadData(vm.resource, true);
                }
            }

            function mapCleanObjects(resourceObj) {
                unwrapLoanApplicationAttributes(resourceObj);
            }
            function updateECIB() {
                if (vm.silkECIBUpdated) {
                    vm.ResourceCopy["TmxCustomerMaster[0].TmxECIBDetail"] = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxECIBDetail;
                    vm.ResourceCopy["TmxCustomerMaster[0].EcibFetchFlag"] = dynamicFormService.applicationData.TmxCustomerMaster[0].EcibFetchFlag;
                }
            }

            function formatJsonForPost() {
                // mapCleanObjects(vm.ResourceCopy,vm.LoanApplicationDataCopy);
                // var guarantorMappingData = angular.copy(dynamicFormService.applicationGuarantorMappingData);
                // var TmxLoanApplicationToGuarantorMapping = TmxLoanApplicationToGuarantorMappingArrayToObjectConversion(guarantorMappingData);   
                // vm.ResourceCopy.TmxLoanApplicationToGuarantorMapping = TmxLoanApplicationToGuarantorMapping;
                unwrapLoanApplicationAttributes(vm.ResourceCopy);
                if (tenantName == TenantsList.SILK) {
                    if (vm.slsUpdated)
                        updateResourceCopy();
                    if (vm.checklistSaved)
                        updateResourceCopyChecklist();
                    if (vm.silkECIBUpdated)
                        updateECIB();
                }
                else
                    vm.mapresource();
                vm.bindRootObjectsToChildObjects();
                makeArrayToObject(vm.ResourceCopy);
                vm.deleteEmptyObjects();
                objectCleaning(vm.ResourceCopy);
                setLoanApplicationChecklist();
            }
            function PerformValidationBeforeSave() {
                if (vm.checklistUpdated && !vm.checklistSaved) {
                    return $filter('translate')("BVSChecklistSavingRequired");
                }
            }
            function setLoanApplicationChecklist() {
                vm.ResourceCopy.TmxLoanApplicationChecklist.forEach(function (item) {
                    if (item.Attachment) {
                        item.MimeType = "";
                        if (item.Attachment.includes('data:image/jpeg;base64') || item.Attachment.includes('data:image/png;base64')) {
                            item.MimeType = "image/png";
                        }
                        else if (item.Attachment.includes('data:application/pdf;base64')) {
                            item.MimeType = "application/pdf";
                        }
                        else if (item.Attachment.includes('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64')) {
                            item.MimeType = "application/xlsx";
                        }
                        else if (item.Attachment.includes('data:image/tiff;base64')) {
                            item.MimeType = "image/tiff";
                        }
                        else if (item.Attachment.includes('data:application/msword;base64') || item.Attachment.includes('data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64')) {
                            item.MimeType = "application/msword";
                        }
                        let metadataIdx = item.Attachment.indexOf(';base64,')
                        item.Attachment = item.Attachment.substring(metadataIdx + 8);
                    }
                });
            }


            function tenantWiseLogic() {
                if ([TenantsList.VITAS, TenantsList.VITAS_EG].includes(tenantName)) {
                    vm.showEMIButton = tmxUtility.checkPermission('CalculateEMI', 'View')
                }
                else if (TenantsList.VITAS_LEB == tenantName) {
                    vm.showEMIButton = tmxUtility.checkPermission('CalculateEMI', 'View')
                    vm.showTranslationButton = tmxUtility.checkPermission('TranslateValuesButton', 'View')
                }
                else if (TenantsList.UBANK == tenantName) {
                    vm.showEcibButton = true;
                    if (tmxUtility.checkPermission('Credit Approval', 'View')) {
                        vm.showCreditButton = true;
                        if (vm.resource && vm.resource.TmxCustomerMaster && vm.resource.TmxCustomerMaster[0] && exists(vm.resource.AppVersionNumber) && vm.resource.AppVersionNumber != 0) {
                            vm.disableCreditButton = true;
                        }
                        else {
                            vm.disableCreditButton = false;
                        }
                    }
                    if (tmxUtility.checkPermission('Loan Disbursement', 'View')) {
                        vm.showDisbursementButton = true;

                    }
                    if (tmxUtility.checkPermission('L2 Account Opening', 'View')) {
                        vm.showAccountButton = true;
                        vm.disableL2Button = true;
                    }
                    if (tmxUtility.checkPermission('Transfer In Wallet', 'View')) {
                        vm.showtransferInWallet = true;
                        vm.disabletransferInWallet = true;
                    }

                    checkButtonVisibility();
                }

                else if (TenantsList.SILK == tenantName) {
                    vm.showEcibButton = false;
                }

            }

            function checkButtonVisibility() {

                vm.disableDisbursementButton = true;
                vm.disableL2Button = true;
                vm.disabletransferInWallet = true;

                if (exists(vm.resource.TmxCustomerMaster) && exists(vm.resource.TmxCustomerMaster[0].TmxCustomerDetail) && !exists(vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].BranchComments)) {
                    vm.disableDisbursementButton = false;
                }

                else if (exists(vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].BranchComments) && !exists(vm.resource.OtherLoanInstituteName)) {
                    vm.disableL2Button = false;
                }

                else if (exists(vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].BranchComments) && exists(vm.resource.OtherLoanInstituteName) && !exists(vm.resource.OtherLoanUsage)) {
                    vm.disabletransferInWallet = false;
                }
                checkActionButtonVisibility();
            }

            function checkActionButtonVisibility() {
                vm.disableActionButton1 = false;
                vm.commands.forEach(e => {
                    if (e.HiddenValue == "Approve" && !vm.disableDisbursementButton) {
                        vm.disableActionButton1 = true;
                    }
                    else if (e.HiddenValue == "SendToCSO") { //enable if AppVersionNumber exists
                        vm.disableActionButton1 = !(exists(vm.resource.AppVersionNumber) && vm.resource.AppVersionNumber != 0);
                    }
                });
            }

            function setButtonsVisiblity() {
                var validateButtonHiddenStatuses = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'HIDE_VALIDATION_ON_STATUS')
                if (exists(validateButtonHiddenStatuses)) {
                    var statusList = validateButtonHiddenStatuses.split(',');
                    if (statusList.indexOf(vm.getStatus()) > -1) {
                        vm.hideValidateButton = true;
                    }
                }

                if (tmxUtility.checkPermission('Validate Service', 'View') && !vm.hideValidateButton) {
                    if (vitasTenants.includes(tenantName)) {
                        vm.disableActionButton1 = true;
                        vm.disableActionButton2 = true;
                    }
                    else if (TenantsList.SAMBA == tenantName || TenantsList.UBANK == tenantName) { //Ubank check added by Adeel 07-01-2020
                        vm.disableActionButton1 = true;
                    }
                }

                vm.showDownloadButton = tmxUtility.checkPermission('Download PDF Button', 'View');
            }

            function setStatusBasedVariables() {
                switch (vm.getStatus()) {
                    case STATUS.NEW:
                    case STATUS.DRAFT:
                        vm.peripherals.mustFields.forEach(function (id) {
                            var field = vm.page.fieldMap.primaryKey["tf" + id];
                            if (exists(field)) {//if the must field exists
                                field.errorControl = {
                                    watch: true,//switch to start watching(updates dynamically)
                                    show: true,//switch to show errors (red red kerdy ga har jagah :3)
                                    enable: true,//gloabl switch to turn on and of validation checkings
                                    validations: {//object to operate each validation individually
                                        required: true,
                                        maxlength: true,
                                        minlength: true
                                    }
                                }
                            }
                        });
                        vm.verifyPage();
                        break;
                    default:
                        break;
                }
            }


            function formatName(name) {
                var arr = name.split(/(?=[A-Z])/);
                var result = "";
                arr.forEach(function (token, index) {
                    result += token;
                    if (index < arr.length - 1) {
                        result += " ";
                    }
                });
                return result;
            }

            function wrapLoanApplicationAttributes(resource) {
                resource.TmxLoanApplication = [];
                resource.TmxLoanApplication[0] = {};
                for (var key in resource) {
                    if (resource.hasOwnProperty(key)) {
                        if (typeof resource[key] !== 'object') {
                            resource.TmxLoanApplication[0][key] = resource[key];
                        }

                    }
                }
            }


            function unwrapLoanApplicationAttributes(resource) {
                if (resource && resource.TmxLoanApplication && resource.TmxLoanApplication[0]) {
                    var insideAttributes = Object.getOwnPropertyNames(resource.TmxLoanApplication[0]);
                    insideAttributes.forEach(item => {
                        resource[item] = resource.TmxLoanApplication[0][item];
                    });
                    delete resource.TmxLoanApplication;
                }

            }

            function takeOutChild(rootObject, objectToTraverse, name = null) {

                if (!exists(objectKeys)) {
                    objectKeys = [];
                }
                if (!exists(objectToTraverse)) return;
                if (Object.prototype.toString.call(objectToTraverse) == '[object Object]') {
                    Object.keys(objectToTraverse).forEach(function (key) {
                        if (Object.prototype.toString.call(objectToTraverse[key]) == '[object Object]' || Object.prototype.toString.call(objectToTraverse[key]) == '[object Array]') {
                            var rootObjectKey;
                            rootObjectKey = name + "." + key;

                            if (Object.prototype.toString.call(objectToTraverse[key]) == '[object Object]') {
                                rootObject[rootObjectKey] = [];
                                rootObject[rootObjectKey][0] = objectToTraverse[key];
                                if (objectKeys.indexOf(rootObjectKey) < 0) {
                                    objectKeys.push(rootObjectKey)
                                }
                            }
                            else {
                                rootObject[rootObjectKey] = objectToTraverse[key];
                            }
                            takeOutChild(rootObject, objectToTraverse[key], rootObjectKey);
                        }
                    });
                }
                else if (Object.prototype.toString.call(objectToTraverse) == '[object Array]') {
                    for (var i = 0; i < objectToTraverse.length; i++) {
                        takeOutChild(rootObject, objectToTraverse[i], name + "[" + i + "]");
                    }
                }
            }

            function objectCleaning(resourceObject) {
                if (resourceObject) {
                    var Obj = resourceObject
                    Object.keys(Obj).forEach(function (objectKey) {
                        if (Object.prototype.toString.call(Obj[objectKey]) == '[object Array]') {
                            Obj[objectKey].forEach(function (innerObject, index) {

                                for (var key in innerObject) {
                                    if (!angular.isDefined(innerObject[key])) {
                                        delete innerObject[key];
                                    }
                                }

                                if (innerObject && Object.getOwnPropertyNames(innerObject).length < 1) {
                                    Obj[objectKey].splice(index, 1);
                                }
                                else {
                                    objectCleaning(innerObject);
                                }
                            })
                        }
                    });
                }
            }

            function tfsManipulation(tfsObject) {
                var allFields = [];
                function extractFields(tab) {
                    if (exists(tab.Tabs) && tab.Tabs.length > 0) { // if there are sub tabs
                        tab.Tabs.forEach(extractFields);
                    }
                    angular.forEach(tab.Fields, function (obj, key) {
                        allFields.push(obj)
                    });
                }

                tfsObject.Tabs.forEach(extractFields);

                objectToIterage = angular.copy(allFields);

                angular.forEach(allFields, function (item) {
                    if (!item.FieldTableName.includes('.')) {
                        try {
                            item.FieldTableName = renameTableName(item);
                        }
                        catch (e) {
                            console.error(e);
                            console.error('Error in field definition', item);
                        }
                    }
                })
            }

            function renameTableName(item) {
                var newParentId = 0;
                var fieldTableName = item.FieldTableName;

                if (item._ParentFieldId) {
                    newParentId = objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0]._ParentFieldId;
                    if (objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName.includes('[]')) {
                        var tableName = angular.copy(objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName.replace('[]', ''));
                        fieldTableName = tableName + '[0].' + item.FieldTableName.replace('[]', '');
                    }
                    else {
                        fieldTableName = objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName + '.' + item.FieldTableName.replace('[]', '');
                    }
                }


                while (newParentId) {
                    var baseObj = objectToIterage.filter(obj => obj.TenantFieldSetupId == newParentId)[0].FieldName;
                    if (baseObj == 'TmxPerson') {
                        fieldTableName = baseObj + '.' + fieldTableName;
                    }
                    else {
                        fieldTableName = baseObj + '[0].' + fieldTableName;
                    }

                    newParentId = objectToIterage.filter(obj => obj.TenantFieldSetupId == newParentId)[0]._ParentFieldId
                }


                var FinalName = fieldTableName.replace('TmxLoanApplication[0].', '');
                FinalName = FinalName.replace('TmxLoanApplication.', '');
                return FinalName;
            }

            function makeObjectToArray(rootObject) {
                objectToArray.add('TmxCustomerMaster[0].TmxECIBDetail[0].TmxeCIBDetailHistoryMap');
                objectToArray.add('TmxCompanyBranch');
                objectToArray.add('TmxProduct');
                objectToArray.add('TmxUser');
                objectToArray.add('TmxUserRoleMapping');
                Object.keys(rootObject).forEach(function (key) {
                    if (Object.prototype.toString.call(rootObject[key]) == '[object Object]') {
                        objectToArray.add(key);
                        var tempObj = angular.copy(rootObject[key]);
                        rootObject[key] = [];
                        rootObject[key][0] = tempObj;
                    }
                });
            }

            function makeArrayToObject(rootObject) {
                objectToArray.forEach(function (key) {
                    if (Object.prototype.toString.call(rootObject[key]) == '[object Array]') {
                        var tempObj = angular.copy(rootObject[key][0]);
                        rootObject[key] = {};
                        rootObject[key] = tempObj;
                    }
                });
            }

            function initQuestion(field, questions) {
                if (field.type == 'question') {
                    if (exists(questions[field.tableObj.tname], "data"))
                        field.setQuestion(questions[field.tableObj.tname].data);
                }
            }

            //#endregion


            //#region  ========== Scope functions ============================

            vm.dataCheck = function () {
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.resource, false);
                formatJsonForPost();

                tmxResource("Enquiry").getByAction("GetBureauCreditReport", false, 'post', vm.ResourceCopy.TmxCustomerMaster[0]).then(function (response) {
                    if (response.status.code == 200) {
                        vm.loanApplicationData = vm.ResourceCopy;
                        vm.resource = vm.ResourceCopy;
                    }
                    if (response.data != null && response.data.url == null && response.data.status && response.data.data && response.data.data.message) {
                        if (response.data.status.code == 404) {
                            TmxDialogService.showConfirmDialog('Error', response.data.data, dataCheckResponseCallBack, null);
                            vm.fileNumber = response.data.data.FileName;
                            vm.transactionNumber = response.data.data.transactionNumber;
                        }
                        else {
                            vm.showSimpleDialog('Error', response.data.data.message.replace(/\|/g, '<br>'));
                        }
                    }
                    else if (response != null && response.data != null && response.data.url != null) {
                        $window.open(response.data.url, "_blank");
                        var url = response.data.url;
                        var dataCheckObj = vm.resource.TmxLoanApplicationChecklist.filter(function (item) {
                            return item.LoanProductChecklistId == DATA_CHECK_LOAN_PRODUCT_CHECKLIST_ID.ConfigurationValue
                        })

                        if (dataCheckObj.length == 0) {
                            dataCheckObj.push({
                                LoanProductChecklistId: DATA_CHECK_LOAN_PRODUCT_CHECKLIST_ID.ConfigurationValue
                            })
                        }
                        dataCheckObj[0].MimeType = "text/html";
                        dataCheckObj[0].AttachmentURL = url;
                        vm.resource.TmxLoanApplicationChecklist.push(dataCheckObj[0]);
                        vm.isPageLoading = true;
                        loadData(vm.resource);
                        vm.isPageLoading = false;
                    }
                });
            }

            vm.calculateDBR = function () {
                vm.isPageLoading = true;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, false);
                formatJsonForPost();

                tmxResource("LoanApplication").getByAction("AggregateDBR", false, 'put', vm.ResourceCopy).then(function (response) {
                    vm.isPageLoading = false;
                    if (response.status.code == 200 || response.status.code == 201) {
                        vm.resource = response.data;
                        vm.loanApplicationData = angular.copy(vm.resource);
                        dynamicFormService.applicationData = vm.resource;
                        loadData(vm.resource, true);
                    }
                });
            }
            vm.creditApproval = function () {
                vm.isPageLoading = true;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, false);
                if (vm.ResourceCopy.TmxCustomerMaster[0].CNICExpiryUdf) {
                    vm.ResourceCopy.TmxCustomerMaster[0].CNICExpiryUdf = new Date(new Date(vm.ResourceCopy.TmxCustomerMaster[0].CNICExpiryUdf).setHours(0, 0, 0, 0));
                }

                //For Ubank BRM Call updated value should go in TmcPersonNationalIdentifier
                vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier[0].NationalIdExpiryDate = vm.ResourceCopy.TmxCustomerMaster[0].CNICExpiryUdf;

                if (vm.ResourceCopy.TmxCustomerMaster[0].NationalIdIssueDateUdf) {
                    vm.ResourceCopy.TmxCustomerMaster[0].NationalIdIssueDateUdf = new Date(new Date(vm.ResourceCopy.TmxCustomerMaster[0].NationalIdIssueDateUdf).setHours(0, 0, 0, 0));
                }
                if (vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth) {
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth = new Date(new Date(vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth).setHours(0, 0, 0, 0));
                }
                mapCleanObjects(vm.ResourceCopy, vm.LoanApplicationDataCopy);
                makeArrayToObject(vm.ResourceCopy);

                tmxResource("Integration").getByAction("createBRMandLoan", false, 'post', vm.ResourceCopy).then(function (response) {
                    vm.isPageLoading = false;
                    if (response != null && response.status != null && (response.status.code == 200 || response.status == 200) && ((response.data != null && (response.data.BRNo || response.data.loanNumber)) || (response.data.data != null && (response.data.data.BRNo || response.data.data.loanNumber)))) {

                        if (response.data.loanApplication) {
                            vm.resource.UtilizationComments = response.data.loanApplication.UtilizationComments;
                            vm.resource.ApprovedLoanAmount = response.data.loanApplication.ApprovedLoanAmount;
                            vm.resource.TotalTenure = response.data.loanApplication.TotalTenure;
                            vm.resource.TotalInstallments = response.data.loanApplication.TotalInstallments;
                            vm.resource.TmxCustomerMaster = response.data.loanApplication.TmxCustomerMaster;
                        }
                        else if (response.data.data && response.data.data.loanApplication) {
                            vm.resource.UtilizationComments = response.data.data.loanApplication.UtilizationComments;
                            vm.resource.ApprovedLoanAmount = response.data.data.loanApplication.ApprovedLoanAmount;
                            vm.resource.TotalTenure = response.data.data.loanApplication.TotalTenure;
                            vm.resource.TotalInstallments = response.data.data.loanApplication.TotalInstallments;
                            vm.resource.TmxCustomerMaster = response.data.data.loanApplication.TmxCustomerMaster;
                        }
                        if (response.data.BRNo)
                            vm.resource.TmxCustomerMaster[0].CustomerCode = response.data.BRNo;
                        else if (response.data.data.BRNo)
                            vm.resource.TmxCustomerMaster[0].CustomerCode = response.data.data.BRNo;

                        if (vm.resource.TmxLoanAppToGuarantorMpg.length > 0 && vm.resource.TmxLoanAppToGuarantorMpg[0].TmxGuarantor) {
                            //Gauarantor BRM
                            if (response.data.GuarantorBRNo) {
                                vm.resource.TmxLoanAppToGuarantorMpg[0].TmxGuarantor.BRMNumberUdf = response.data.GuarantorBRNo;
                            }
                            else if (response.data.data.GuarantorBRNo) {
                                vm.resource.TmxLoanAppToGuarantorMpg[0].TmxGuarantor.BRMNumberUdf = response.data.data.GuarantorBRNo;
                            }
                        }

                        if (response.data.loanNumber)
                            vm.resource.AppVersionNumber = response.data.loanNumber;
                        else
                            vm.resource.AppVersionNumber = response.data.data.loanNumber;

                        if (exists(vm.resource.AppVersionNumber) && vm.resource.AppVersionNumber != 0) {
                            vm.disableCreditButton = true;
                            vm.disableActionButton1 = false;
                        }

                        vm.loanApplicationData = angular.copy(vm.resource);
                        dynamicFormService.applicationData = vm.resource;
                        loadData(vm.resource);
                    }
                    else {
                        if (exists(response.data.Message)) {
                            ToastService.showCustomToast('error', response.data.Message)
                        }
                        else {
                            ToastService.showCustomToast('error', response.data.errorMsg)
                        }
                        return;
                    }
                });
            }

            vm.loanDisbursement = function () {
                vm.isPageLoading = true;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, false);
                mapCleanObjects(vm.ResourceCopy, vm.LoanApplicationDataCopy);
                makeArrayToObject(vm.ResourceCopy);

                tmxResource("Integration").getByAction("createDisbursement", false, 'post', vm.ResourceCopy).then(function (response) {
                    vm.isPageLoading = false;
                    if (response != null && response.status != null && response.status.code == 200 && ((response.data != null && response.data.AddResult == true && response.data.disburseResult) || (response.data != null && response.data.data != null && response.data.data.AddResult == true && response.data.data.disburseResult))) {

                        if (vm.resource.TmxCustomerMaster && vm.resource.TmxCustomerMaster[0].TmxCustomerDetail && vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0]) {
                            if (response.data.disburseResult)
                                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].BranchComments = response.data.disburseResult;
                            else if (response.data.data.disburseResult)
                                vm.resource.TmxCustomerMaster[0].TmxCustomerDetail[0].BranchComments = response.data.data.disburseResult;
                            vm.disableDisbursementButton = true;
                            vm.disableL2Button = false;
                            vm.disabletransferInWallet = false;
                            checkActionButtonVisibility();
                            if (response.data.loanApplication) {
                                vm.resource.UtilizationComments = response.data.loanApplication.UtilizationComments;
                                vm.resource.ApprovedLoanAmount = response.data.loanApplication.ApprovedLoanAmount;
                                vm.resource.TotalTenure = response.data.loanApplication.TotalTenure;
                                vm.resource.TotalInstallments = response.data.loanApplication.TotalInstallments;
                            }
                            else if (response.data.data && response.data.data.loanApplication) {
                                vm.resource.UtilizationComments = response.data.data.loanApplication.UtilizationComments;
                                vm.resource.ApprovedLoanAmount = response.data.data.loanApplication.ApprovedLoanAmount;
                                vm.resource.TotalTenure = response.data.data.loanApplication.TotalTenure;
                                vm.resource.TotalInstallments = response.data.data.loanApplication.TotalInstallments;
                            }
                            vm.loanApplicationData = angular.copy(vm.resource);
                            dynamicFormService.applicationData = vm.resource;
                            loadData(vm.resource);
                        }
                    }
                    else {
                        ToastService.showCustomToast('error', response.data.errorMsg)
                        return;

                    }
                });
            }
            vm.openL2Account = function () {
                vm.isPageLoading = true;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, false);
                mapCleanObjects(vm.ResourceCopy, vm.LoanApplicationDataCopy);
                makeArrayToObject(vm.ResourceCopy);
                tmxResource("Integration").getByAction("createL2Account", false, 'post', vm.ResourceCopy).then(function (response) {
                    vm.isPageLoading = false;
                    if (response != null && response.status != null && response.status.code == 200 && response.data != null && response.data.responseMessage == "Success" && response.data.responseCode == "000") {

                        if (vm.resource) {
                            vm.resource.OtherLoanInstituteName = response.data.mobileAccountNumber;
                            vm.resource.ChannelReferenceId = response.data.referenceTxnId;
                            vm.resource.OtherLoanTotalAmount = response.data.reservedField1;
                            vm.loanApplicationData = angular.copy(vm.resource);
                            dynamicFormService.applicationData = vm.resource;
                            loadData(vm.resource);
                            vm.disableL2Button = true;
                            vm.disableDisbursementButton = true;
                            vm.disabletransferInWallet = false;
                            checkActionButtonVisibility();
                        }
                    }
                    else {
                        if (response != null && response.data != null) {
                            ToastService.showCustomToast('error', response.data.responseMessage)
                            return;
                        }
                        else if (response != null && response.status != null && response.status.code != 200) {
                            ToastService.showCustomToast('error', response.status.message)
                            return;
                        }
                    }
                });
            }

            vm.transferInWallet = function () {
                vm.isPageLoading = true;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, false);
                mapCleanObjects(vm.ResourceCopy, vm.LoanApplicationDataCopy);
                makeArrayToObject(vm.ResourceCopy);

                tmxResource("Integration").getByAction("transferInWallet", false, 'post', vm.ResourceCopy).then(function (response) {
                    vm.isPageLoading = false;
                    if (response != null && response.status != null && response.status.code == 200 && response.data != null && response.data.ResponseMessage == "Success" && response.data.ResponseCode == "000") {

                        if (vm.resource) {
                            vm.resource.OtherLoanUsage = response.data.result;
                            vm.resource.ChannelReferenceId = response.data.bankAccountNumber;
                            vm.resource.OtherLoanTotalAmount = response.data.Amount;
                            vm.loanApplicationData = angular.copy(vm.resource);
                            dynamicFormService.applicationData = vm.resource;
                            loadData(vm.resource);
                            vm.disabletransferInWallet = true;
                            vm.disableL2Button = true;
                            vm.disableDisbursementButton = true;
                            checkActionButtonVisibility();
                        }
                    }
                    else {
                        if (response != null && response.data != null) {
                            ToastService.showCustomToast('error', response.data.responseMessage)
                            return;
                        }
                        else if (response != null && response.status != null && response.status.code != 200) {
                            ToastService.showCustomToast('error', response.status.message)
                            return;
                        }
                    }
                });
            }
            function setupFieldMap(page,guarantorTabId) {
                var pageFieldMap = vm.page.tabs.filter(x=> x.id == guarantorTabId).fieldMap;
                page.fieldMap.all = page.fieldMap.all.filter(x => x != undefined);
                if (tmxUtility.exists(pageFieldMap, 'all')) {
                    var existingFieldIds = page.fieldMap.all.map(x => x.id);
                    var allPageFields = pageFieldMap.all.filter(x => x != undefined).filter(y => !existingFieldIds.includes(y.id));
                    page.fieldMap.all.push(...allPageFields);
                }
                if (tmxUtility.exists(pageFieldMap, 'primaryKey')) {
                    Object.keys(pageFieldMap.primaryKey).forEach(key => {
                        if (!tmxUtility.exists(page.fieldMap.primaryKey[key])) {
                            page.fieldMap.primaryKey[key] = pageFieldMap.primaryKey[key];
                        }
                    });
                }

            }
            vm.loadDynamicGuarantorFields = function(pageCopy) {
                if (vm.loanApplicationData && vm.loanApplicationData.TmxLoanApplicationToGuarantorMapping) {
                    var guarantorTabId = pageCopy.tabs.find(x=> x.defaultValue == 'Guarantors').id;
                    pageCopy.tabs = pageCopy.tabs.filter(x => x.id != guarantorTabId); //Remove existing fields and add again after executing formulae
                    var errorControl = { // To configure validation behaviour and which checks to open
                        watch: true,//switch to start watching(updates dynamically)
                        show: true,//switch to show errors (red red kerdy ga har jagah :3)
                        enable: true,//gloabl switch to turn on and of validation checkings
                        validations: {//object to operate each validation individually
                            required: true,//only for new loan app and draft loan app, required checking must be disabled
                            maxlength: true,
                            minlength: true
                        }
                    };
                    var peripherals = {
                        mustFields: [],//fields that must be filled irresepective of state of loan app
                        locals: {
                        }
                    }
                    var pageSchema = dynamicFormService.pageSchema.Tabs.find(x => x.TabId == guarantorTabId);
                    pageSchema.Fields.forEach(setFieldTableName);
                    pageSchema.Tabs.forEach(tab => tab.Fields.forEach(setFieldTableName));
                    vm.loanApplicationData.TmxLoanApplicationToGuarantorMapping.forEach((selectedGuarantor)=> {

                        var jsonObject = {
                            'TmxGuarantor': angular.copy(selectedGuarantor.TmxGuarantor)
                        };
                        
                        //dynamicFormService.tfsManipulation(pageSchema);
                        objectKeys.push(...dynamicFormService.takeOutAllChilds(jsonObject, jsonObject.TmxGuarantor, 'TmxGuarantor'));
                        jsonObject['TmxGuarantor'] = [jsonObject['TmxGuarantor']];        // make root object as an array    
                        var newTab = dynamicFormService.loadPage(pageSchema, undefined, errorControl, peripherals);
                        setupFieldMap(newTab, guarantorTabId);
                        newTab.registerDependants();
                        newTab.read(jsonObject, newTab.fieldMap);
                        newTab.skipTabInPageValidation = true;// skip validation because tab is already validated
                        if(culture && culture == 'ar') {
                            pageCopy.tabs.splice(0,0,newTab);
                        }
                        else {
                            pageCopy.tabs.push(newTab);
                        }
                    });
                    
                    function setFieldTableName(field) {
                        field.FieldTableName = field.FieldTableName.replace('TmxGuarantor[0]', 'TmxGuarantor');
                    }
                }
            }
            vm.print = function (ev) {
                if (exists(vm.page)) {
                    var ProductName;
                    var ProductId;
                    if (exists(vm.resource) && exists(vm.resource.TmxCustomerMaster) && exists(vm.resource.TmxCustomerMaster[0])) {
                        var CustomerMasterId = vm.resource.TmxCustomerMaster[0].CustomerMasterId;
                        var CustomerName = vm.resource.TmxCustomerMaster[0].CustomerName;
                    }
                    if (exists(vm.resource) && exists(vm.resource.TmxProduct)) {
                        ProductName = Array.isArray(vm.resource.TmxProduct) ? vm.resource.TmxProduct[0].ProductName : vm.resource.TmxProduct.ProductName;
                        ProductId = Array.isArray(vm.resource.TmxProduct) ? vm.resource.TmxProduct[0].ProductId : vm.resource.TmxProduct.ProductId;
                    }
                    vm.ResourceCopy = angular.copy(vm.resource);
                    vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);

                    var pageCopy = angular.copy(vm.page);
                    
                    var isGuarantorTabDynamic = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'IS_GUARANTOR_DYNAMIC', true, vm.loanApplicationData.LoanProductId) == true;
                    if (isGuarantorTabDynamic) {
                        vm.loadDynamicGuarantorFields(pageCopy);
                    }
                    vm.mapresource();

                    $mdDialog.show({
                        controller: 'PrintCtrl',
                        templateUrl: 'app/private/transaction/loan-application/edit/Print.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        locals: {
                            page: pageCopy,
                            data: vm.ResourceCopy,
                            CustomerId: CustomerMasterId,
                            ProductName: ProductName,
                            ProductId: ProductId,
                            CustomerName: CustomerName,
                            getVisibleValue: vm.getVisibleValue,
                            signatureCaptured: vm.signatureCaptured,
                            loanApplicationData: vm.loanApplicationData,
                            isGuarantorTabDynamic: isGuarantorTabDynamic
                        },
                        clickOutsideToClose: true,
                        fullscreen: true,
                    })
                        .then(function () {

                        }, function () {

                        });

                }
            }

            vm.generateOTP = function () {
                vm.isPageLoading = true;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, false);
                formatJsonForPost();
                if (angular.isDefined(vm.ResourceCopy.TmxSmartAdvance) && vm.ResourceCopy.TmxSmartAdvance.length > 0) {
                    if (angular.isDefined(vm.ResourceCopy.TmxSmartAdvance[0].AdvanceAmount) && vm.ResourceCopy.TmxSmartAdvance[0].AdvanceAmount != "" && angular.isDefined(vm.ResourceCopy.TmxSmartAdvance[0].ServiceFees) && vm.ResourceCopy.TmxSmartAdvance[0].ServiceFees != "") {

                        if (angular.isDefined(vm.LoanApplicationDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact[0].ContactNumber)) {
                            var contactNumber = vm.LoanApplicationDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact[0].ContactNumber;
                            tmxResource('OTP').getByAction('GenerateOTP/' + contactNumber, true, 'get').then(function (response) {
                                vm.isPageLoading = false;
                                if (response.status.code == 200 || response.status.code == 201) {
                                    ToastService.showCustomToast("success", response.status.message);
                                }
                                else {
                                    ToastService.showCustomToast("error", response.status.message);
                                }
                            });
                        }
                        else {
                            ToastService.showCustomToast("error", "Please add customer contact number.");
                        }
                    }
                    else {
                        ToastService.showCustomToast("error", "Please calculate service fee and then generate OTP.");
                    }
                }
                else {
                    ToastService.showCustomToast("error", "Please calculate service fee and then generate OTP.");
                }
                vm.isPageLoading = false;
            }

            vm.verifyOTP = function () {
                vm.isPageLoading = true;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, false);
                formatJsonForPost();
                if (angular.isDefined(vm.ResourceCopy.TmxCustomerMaster[0].OTP) && vm.ResourceCopy.TmxCustomerMaster[0].OTP != "") {
                    if (angular.isDefined(vm.LoanApplicationDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact[0].ContactNumber)) {
                        var contactNumber = vm.LoanApplicationDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact[0].ContactNumber;
                        var otp = vm.ResourceCopy.TmxCustomerMaster[0].OTP;
                        tmxResource('OTP').getByAction('VerifyOTP/' + contactNumber + '/' + otp, true, 'get').then(function (response) {
                            vm.isPageLoading = false;
                            if (response.status.code == 200 || response.status.code == 201) {
                                ToastService.showCustomToast("success", response.status.message);
                            }
                            else {
                                ToastService.showCustomToast("default", response.status.message);
                            }
                        });
                    }
                    else {
                        ToastService.showCustomToast("error", "Please add customer contact number.");
                    }
                    checkActionButtonVisibility();
                }
                else {
                    ToastService.showCustomToast("error", "Please enter OTP.");
                }
                vm.isPageLoading = false;
            }

            vm.checkValidity = function () {

                updateResource();
                updateSlsFrmuEligibilityParams();

                if (!(exists(SlsFrmuEligibilityParams.CompanyName) &&
                    exists(SlsFrmuEligibilityParams.MonthlyIncomeAmount) &&
                    SlsFrmuEligibilityParams.MonthlyIncomeAmount > 0 &&
                    exists(SlsFrmuEligibilityParams.GrossIncomeAmount) &&
                    SlsFrmuEligibilityParams.GrossIncomeAmount > 0 &&
                    exists(SlsFrmuEligibilityParams.SegmentLkp) &&
                    exists(SlsFrmuEligibilityParams.ProfessionTypeLkp) &&
                    exists(SlsFrmuEligibilityParams.loanAppId) &&
                    exists(SlsFrmuEligibilityParams.DOB) &&
                    SlsFrmuEligibilityParams.DOB != 'N/A' &&
                    exists(SlsFrmuEligibilityParams.NAME) &&
                    exists(SlsFrmuEligibilityParams.CNIC) &&
                    exists(SlsFrmuEligibilityParams.AreaCode) && !(tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'SHOW_CRITERIA_SELECTION', true, dynamicFormService.applicationData.LoanProductId) && (SlsFrmuEligibilityParams.Criteria == "" || !(exists(SlsFrmuEligibilityParams.Criteria)))))) {
                    ToastService.showCustomToast('error', 'Please Fill Required Fields');
                    return;
                }

                checkSLS();
            }

            vm.evaluateRule = function () {
                vm.isPageLoading = true;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, false);
                formatJsonForPost();

                tmxResource('LoanApplication').getByAction('EvaluateRules', false, 'put', vm.ResourceCopy).then(function (response) {
                    vm.isPageLoading = false;
                    if (response.data && !exists(response.data.data)) {
                        var data = response.data;
                        response.data = {};
                        response.data.data = {};
                        response.data.data = data;
                    }
                    if (response.data && response.data.data && (response.data.data.manualDeviation || response.data.data.warning || response.data.data.error || response.data.data.data))
                        showEvaluationRulesDialog(response.data.data, true);
                    else
                        ToastService.showCustomToast('success', 'No rule is voilated & no Deviation/Warning occurred.');
                    // if (response.data.data) {
                    //     showEvaluationRulesDialog(response.data.data, true);
                    // }
                });
            }

            vm.showSimpleDialog = function (title, message, callback) {
                var alertConfig = {
                    title: title,
                    htmlContent: message,
                    ok: 'Close'
                };
                var alert = $mdDialog.alert(alertConfig);
                $mdDialog
                    .show(alert)
                    .finally(function () {
                        alert = undefined;
                        if (exists(callback)) callback();
                    });
            }

            vm.verifyPage = function () {
                vm.page.verify(function () {
                });
            }

            vm.calculateEMI = function () {
                var RequestedLoanAmount = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxLoanApplication_RequestedLoanAmount' });
                var TotalInstallments = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxLoanApplication_TotalInstallments' });
                var LoanSubProductEMI = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxLoanApplicationDetail_LoanSubProductEMI' });
                var InstallmentAmount = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxLoanApplication_InstallmentAmount' });

                RequestedLoanAmount = RequestedLoanAmount ? RequestedLoanAmount[0].value : false;
                TotalInstallments = TotalInstallments ? TotalInstallments[0].value : false;
                LoanSubProductEMI = LoanSubProductEMI ? LoanSubProductEMI[0].value : false;

                if(tenantName == TenantsList.VITAS_EG){
                    var LORecommendedTerm = vm.page.fieldMap.all.filter(function(item) {return item.form_name == 'TmxLoanApplicationRecommendation{"RoleLkp":1}_RecommendedLoanTerms'})
                    TotalInstallments = LORecommendedTerm ? LORecommendedTerm[0].value : 0;

                }

                var body = {
                    "LoanProductParameterSetId": LoanSubProductEMI,
                    "RepaymentTerm": TotalInstallments,
                    "LoanAmount": RequestedLoanAmount
                }

                if (RequestedLoanAmount && TotalInstallments && LoanSubProductEMI) {
                    tmxResource("Integration").getByAction("CalculateEMI", false, 'post', body).then(function (response) {
                        if (response.status.code == 200) {
                            if (InstallmentAmount[0]) {
                                InstallmentAmount[0].value = response.data.Amount;
                            }

                        }
                    })
                }
                else {
                    ToastService.showCustomToast("default", "Please Enter EMI Calculation Fields");
                }
            }

            vm.translateValues = function () {
                var DictAddress = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson_CustPR' });

                var City = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson_CustTown' });
                var Area = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson_CustDistrict' });
                var Suburb = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson_CustCaza' });
                var AddressArabic = vm.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson_CustPRArabic' });


                var AddressLocation = DictAddress ? DictAddress[0].value : false;
                var LocationLookupId = Suburb ? Suburb[0].value : false;


                var body = {
                    "DictAddress": AddressLocation ? AddressLocation : null,
                    "LocationLookupId": LocationLookupId ? LocationLookupId : null
                }

                if (AddressLocation || LocationLookupId) {
                    tmxResource("Integration").getByAction("TranslateModelValues", false, 'post', body).then(function (response) {
                        if (response.status.code == 200) {
                            if (AddressArabic[0]) {
                                AddressArabic[0].value = response.data.AddressArabic;
                                DictAddress[0].value = response.data.DictAddress;
                            }
                            if (exists(response.data.AddressLocation)) {
                                if (City[0]) {
                                    City[0].value = response.data.AddressLocation.City;//tmxUtility.getPropertyValue(lookupService.getLookupById(response.data.AddressLocation.City),"VisibleValue");
                                }
                                if (Area[0]) {
                                    Area[0].value = response.data.AddressLocation.Area;// tmxUtility.getPropertyValue(lookupService.getLookupById(response.data.AddressLocation.Area),"VisibleValue");
                                }
                                if (Suburb[0]) {
                                    Suburb[0].value = response.data.AddressLocation.Suburb; // tmxUtility.getPropertyValue(lookupService.getLookupById(response.data.AddressLocation.Suburb),"VisibleValue");
                                }

                            }
                        }

                    })
                }
                else {
                    ToastService.showCustomToast("default", "Please select an address to translate.");
                }
            }

            vm.validateEntity = function () {
                var fillManadtory = vm.getStatus() == STATUS.NEW || vm.getStatus() == STATUS.DRAFT;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, fillManadtory);
                formatJsonForPost();

                tmxResource("Integration").getByAction("ValidateEntity", false, 'post', vm.ResourceCopy).then(function (response) {
                    if (!exists(response)) {
                        ToastService.showCustomToast("default", "Error in calling the service");
                        return;
                    }
                    if (response.status.code == 200) {
                        if (response.data.Success == true) {
                            vm.disableActionButton1 = false;
                            vm.disableActionButton2 = false;
                            ToastService.showCustomToast("success", "Validation successful.");

                        }
                        else {
                            var validationText = "";
                            if (exists(response.data) && response.data.Errors.length > 0) {
                                response.data.Errors.forEach(function (val) {
                                    validationText += val + "<br>";
                                });
                            }
                            vm.showSimpleDialog("Validation Rules", validationText);
                        }
                    }
                    else {
                        ToastService.showCustomToast("default", response.status.message);
                    }
                });

            }

            vm.calculateFee = function () {

                var fillManadtory = vm.getStatus() == STATUS.NEW || vm.getStatus() == STATUS.DRAFT;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, fillManadtory);
                formatJsonForPost();

                if (angular.isDefined(vm.ResourceCopy.TmxSmartAdvance[0].AdvanceAmount) && vm.ResourceCopy.TmxSmartAdvance[0].AdvanceAmount != "") {
                    if (parseFloat(vm.ResourceCopy.TmxSmartAdvance[0].AdvanceAmount) <= parseFloat(vm.ResourceCopy.TmxCustomerMaster[0].LSA)) {
                        vm.ResourceCopy.TmxSmartAdvance[0].ProductId = vm.ResourceCopy.LoanProductId;
                        vm.ResourceCopy.TmxSmartAdvance[0].CustomerMasterId = vm.ResourceCopy.TmxCustomerMaster[0].CustomerMasterId;
                        vm.ResourceCopy.TmxSmartAdvance[0].LoanApplicationID = vm.ResourceCopy.LoanApplicationId;
                        tmxResource("SmartAdvance").getByAction("CalculateServiceFeee", false, 'post', vm.ResourceCopy.TmxSmartAdvance[0]).then(function (response) {
                            if (!exists(response)) {
                                ToastService.showCustomToast("default", "Error in calling the service");
                                return;
                            }
                            if (response.status.code == 200) {
                                vm.resource.TmxSmartAdvance = [];
                                vm.resource.TmxSmartAdvance.push(response.data);
                                loadData(vm.resource);
                            }
                            else {
                                ToastService.showCustomToast("default", response.status.message);
                            }
                        });
                    }
                    else {
                        if (vm.resource.TmxSmartAdvance.length > 0) {
                            vm.resource.TmxSmartAdvance[0].ServiceFees = null;
                            vm.resource.TmxSmartAdvance[0].AdvanceAmount = vm.ResourceCopy.TmxSmartAdvance[0].AdvanceAmount;
                            loadData(vm.resource);
                        }
                        ToastService.showCustomToast("default", "Advance amount cannot be greater than Loan suggested amount.")
                    }
                }
                else {

                    ToastService.showCustomToast("default", "Please enter advance amount to calculate fee.")
                }
            }

            vm.downloadCreditReport = function () {
                vm.isPageLoading = true;
                var fillManadtory = vm.getStatus() == STATUS.NEW || vm.getStatus() == STATUS.DRAFT;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, fillManadtory);
                formatJsonForPost();

                $http.put(APP_CONSTANTS.backend + 'Integration/CreditReport', vm.ResourceCopy, { responseType: 'arraybuffer' }).success(function (response) {
                    //tmxResource("Integration").getByAction("CreditReport", false, 'put', vm.ResourceCopy).then(function (response) {
                    if (response == "") {
                        ToastService.showCustomToast("default", "No data returned");
                        vm.isPageLoading = false;
                    }
                    else {

                        var file = new Blob([response], { type: 'application/pdf' });
                        if (file.size != 0) {
                            saveAs(file, "Credit Report.pdf");
                            if (TenantsList.VITAS == tenantName && vm.resource.TmxCustomerMaster.length > 0) { //to prevent subjectcode overwrite on save
                                tmxResource("CustomerMaster").getById(vm.resource.TmxCustomerMaster[0].CustomerMasterId).then(response => {
                                    if (response && response.status.code == 200 && response.data) {
                                        vm.resource.TmxCustomerMaster[0].CBSubjectCode = response.data.CBSubjectCode;
                                    }
                                    vm.isPageLoading = false;
                                });
                            }
                        }

                        else {
                            ToastService.showCustomToast("default", "Error occured in generating the credit report, check logs for details.");
                            vm.isPageLoading = false;
                        }
                    }

                });

            }

            vm.formChange = function () {
                if (vitasTenants.includes(tenantName) && tmxUtility.checkPermission('Validate Service', 'View') && !vm.hideValidateButton) {
                    vm.disableActionButton1 = true;
                    vm.disableActionButton2 = true;
                }
                else if (TenantsList.SAMBA == tenantName && tmxUtility.checkPermission('Validate Service', 'View')) {
                    vm.disableActionButton1 = true;
                }
            }

            vm.saveAndLeave = function () {
                vm.isPageLoading = true;
                if (tenantName == TenantsList.SILK) {
                    var validationMessage = PerformValidationBeforeSave();
                    if (validationMessage != null) {
                        validationMessage = validationMessage || "" + $filter('translate')("FillRequiredFields");
                        ToastService.showCustomToast("error", validationMessage);
                        vm.isPageLoading = false;
                        return;
                    }
                }
                vm.errorControl.validations.required = false;
                vm.removeViolatedBizRules();
                vm.errorType = 'dynamic';
                vm.save(function () {
                    dynamicFormService.applicationData = vm.resource;
                    loadData(vm.resource, false); //reload schema for grids
                    $scope.$broadcast("reloadSlsAndFrmuData", {});
                    vm.slsUpdated = false;
                    vm.isPageLoading = false;
                });
            }

            vm.save = function (callback) {
                if (exists(vm.page)) {
                    var fillManadtory = vm.getStatus() == STATUS.NEW || vm.getStatus() == STATUS.DRAFT;
                    vm.ResourceCopy = angular.copy(vm.resource);
                    vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);

                    vm.page.write(vm.ResourceCopy, fillManadtory);
                    formatJsonForPost();
                    vm.verifyPage();
                    if (!vm.page.isValid) {
                        vm.isPageLoading = false;
                        var alert = {
                            title: 'Save Failed Due To Invalid Fields',
                            message: 'Loan Application could not proceed to save due to some invalid fields. Please rectify the invalid fields in order to be able to save the Loan Application.',
                        };
                        vm.showSimpleDialog(alert.title, alert.message);
                        return;//don't proceed with saving
                    }
                    // vm.ResourceCopy.TmxLoanApplicationToGuarantorMapping = TmxLoanApplicationToGuarantorMappingArrayToObjectConversion(dynamicFormService.applicationGuarantorMappingData);

                    vm.ResourceCopy.$saveOrUpdate().then(function (response) {
                        if (!response || response.status < 0) { // In case of network error
                            vm.isPageLoading = false;
                            ToastService.showCustomToast("default", "Loan Application saving failed, no response received from server.");
                            return;
                        }
                        if (response.status > 200) {
                            vm.isPageLoading = false;
                            if (response.status > 500) {
                                ToastService.showCustomToast("default", "Loan Application saving failed, an error occurred on server.");
                            }
                            else {
                                ToastService.showCustomToast("default", "Loan Application saving failed.");
                            }
                            console.error("Error in saving application, response from server: ", response);
                            return;
                        }
                        vm.resource = response.data;


                        var responseStatusCode = response.status.code != undefined ? response.status.code : response.status;
                        // eslint-disable-next-line no-unused-vars
                        var responseStatus;
                        vm.saveSuccess = responseStatusCode;
                        if (exists(response)) {
                            switch (responseStatusCode) {
                                case 200:
                                case 201:
                                case 202:
                                    responseStatus = "success";
                                    break;
                                default:
                                    responseStatus = "error";
                            }
                        }
                        else {
                            ToastService.showCustomToast("default", "Loan Application saving failed due to unknown error");
                        }
                        callback();
                    });
                }
            }

            vm.reset = function () {
                if (exists(vm.page) && exists(vm.loanApplicationData)) {
                    vm.page.read(vm.loanApplicationData);
                    $(".k-datetimepicker input").val('');
                }
            }

            vm.bindRootObjectsToChildObjects = function () {

                rootKeys = Object.getOwnPropertyNames(vm.ResourceCopy);
                rootKeys = rootKeys.filter(function (item) {
                    return item.includes(".");
                })
                rootKeys.forEach(item => {
                    if (Object.prototype.toString.call(vm.ResourceCopy[item]) === "[object Object]" && vm.ResourceCopy[item].type) {
                        vm.ResourceCopy[item] = JSON.parse(kendo.stringify(vm.ResourceCopy[item]))
                    }
                    if (Object.prototype.toString.call(vm.ResourceCopy[item]) === '[object Array]' && objectKeys.indexOf(item) < 0 && !(keyThatAreActuallyObject.indexOf(item) > -1)) {

                        try {
                            /*jshint evil:true */
                            eval("vm.ResourceCopy." + item + " = vm.ResourceCopy[item]");
                        }
                        catch (exception) {
                            console.log('Error Occured In Evaluating ' + item);
                        }
                    }
                    else if (Object.prototype.toString.call(vm.ResourceCopy[item]) === '[object Array]' && (objectKeys.indexOf(item) > 0 || keyThatAreActuallyObject.indexOf(item) > -1)) {
                        if (vm.ResourceCopy[item][0]) {
                            try {
                                /*jshint evil:true */
                                eval("vm.ResourceCopy." + item + " = vm.ResourceCopy[item][0]");
                            }
                            catch (exception) {
                                console.log('Error Occured In Evaluating ' + item);
                            }
                        }
                    }
                });
            }
            vm.deleteEmptyObjects = function () {

                rootKeys.forEach(function (item) {
                    delete vm.ResourceCopy[item];
                });
            }

            vm.mapresource = function () {

                vm.ResourceCopy.TmxLoanApplicationToGuarantorMapping = vm.LoanApplicationDataCopy.TmxLoanApplicationToGuarantorMapping;
                vm.ResourceCopy.TmxLoanAppToGuarantorMpg = vm.LoanApplicationDataCopy.TmxLoanAppToGuarantorMpg;
                vm.ResourceCopy.TmxCustomerMaster[0].negarea = vm.LoanApplicationDataCopy.TmxCustomerMaster[0].negarea;
                vm.ResourceCopy.TmxCustomerMaster[0].negcustomer = vm.LoanApplicationDataCopy.TmxCustomerMaster[0].negcustomer;
                if (angular.isDefined(vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail) &&
                    angular.isDefined(vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0]) &&
                    angular.isDefined(vm.LoanApplicationDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail) &&
                    angular.isDefined(vm.LoanApplicationDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0]) && TenantsList.SILK == tenantName) {
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = vm.LoanApplicationDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness;
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer = vm.LoanApplicationDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer;
                }
                vm.ResourceCopy.TmxCustomerMaster[0].FRMUStatus = vm.LoanApplicationDataCopy.TmxCustomerMaster[0].FRMUStatus;
                vm.ResourceCopy.TmxCustomerMaster[0].SLSStatus = vm.LoanApplicationDataCopy.TmxCustomerMaster[0].SLSStatus;
                vm.ResourceCopy.TmxCustomerMaster[0].PerAddressLine3UDF = vm.LoanApplicationDataCopy.TmxCustomerMaster[0].PerAddressLine3UDF;

                var data = lookupService.getLocalLookupsByType(lkupType.ID_TYPE)
                if (data) {
                    data.filter(function (item) {
                        if (item.VisibleValue == "NIC Number (ID-N)")
                            vm.cnicLookupId = item.LookupId;
                    });
                }

                vm.cnicData = vm.LoanApplicationDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.filter(function (item) {
                    return item.NationalIdTypeLkp == vm.cnicLookupId
                })[0];
                if (angular.isDefined(vm.cnicData))
                    vm.cnic = vm.cnicData.NationalIdentifierValue;
                if (angular.isDefined(vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier)) {
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.filter(function (item) {
                        if (item.NationalIdTypeLkp && item.NationalIdTypeLkp == vm.cnicLookupId)
                            item.NationalIdentifierValue = vm.cnic;
                    });
                }
                else {
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier = vm.LoanApplicationDataCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier
                }
                if (tenantName == TenantsList.UBANK && vm.ecibUpdated) {
                    vm.ResourceCopy["TmxCustomerMaster[0].TmxECIBDetail"] = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxECIBDetail;
                    vm.ResourceCopy["TmxCustomerMaster[0].EcibFetchFlag"] = dynamicFormService.applicationData.TmxCustomerMaster[0].EcibFetchFlag;
                    vm.ResourceCopy.TmxCustomerMaster[0].EcibFetchFlag = dynamicFormService.applicationData.TmxCustomerMaster[0].EcibFetchFlag;
                }
                if(vm.reloadDocuments) {
                    vm.ResourceCopy.TmxLoanApplicationChecklist= dynamicFormService.applicationData.TmxLoanApplicationChecklist;

                }
            }

            vm.submitCommand = function (command, ev) {

                vm.errorControl.validations.required = true;
                //remove any biz rules invalidations if any..
                vm.removeViolatedBizRules();
                vm.errorType = 'dynamic';//set error type back to dynamic 

                vm.verifyPage();
                $timeout(function () { // Chopsoy: vm.page.isValid was being updated after this check has passed. so we have waited for UI hook to perform the validation check
                    if (!vm.page.isValid) {
                        vm.isPageLoading = false;
                        var alert = {
                            title: 'Action Failed Due To Invalid Fields',
                            message: 'Loan Application could not proceed to submit due to some invalid fields. Please rectify the invalid fields in order to be able to submit the Loan Application.',
                        };
                        vm.showSimpleDialog(alert.title, alert.message);
                        return;//don't proceed with submitting
                    }
                    else {
                        showCommentDialog(command, ev);
                        return;
                    }
                }, 500);
            }
            
            var findApplicationChecklist = function (productId, TmxLoanApplicationChecklist) {
                var LoanApplicationChecklist = null;
                TmxLoanApplicationChecklist.forEach(function (dataItem) {
                    if (productId == dataItem.LoanProductChecklistId)
                        LoanApplicationChecklist = dataItem;
                })
                return LoanApplicationChecklist;
            }

            var attachECIBDoc = function (ecibPDFpath) {
                try {
                    $http.get(ecibPDFpath, { responseType: 'blob' }).success(function (res) {
                        if (res) {
                            $scope.$emit("loading", "true");
                            const reader = new FileReader();
                            var applicationCheckListObj = findApplicationChecklist(ecibProductChecklistId, vm.resource.TmxLoanApplicationChecklist);
                            if (!applicationCheckListObj) {
                                $scope.$emit("loadingComplete", "");
                                ToastService.showCustomToast("error", "Document not found in Checklist.");
                                return;
                            }
                            if (applicationCheckListObj.AttachmentURL && applicationCheckListObj.AttachmentURL.length > 0) { //ECIB is already uploaded
                                $scope.$emit("loadingComplete", "");
                                window.open(applicationCheckListObj.AttachmentURL, '_blank');
                                return;
                            }
                            reader.onloadend = function (event) {
                                var base64data = reader.result.split('base64,')[1];
                                var applicationChecklistImageViewModel = {
                                    LoanApplicationChecklistId: applicationCheckListObj.LoanApplicationChecklistId,
                                    AttachmentURL: 'Dummy Attachment URL',
                                    FileData: base64data,
                                    ImageData: "Empty Image Data",
                                    MimeType: "application/pdf"
                                };
                                tmxResource('LoanApplication').getByAction('UploadFile', false, 'post', applicationChecklistImageViewModel).then(function (response) {
                                    if (response && response.data && response.status && response.status.code == 200) {
                                        ecibAttachmentURL = response.data.AttachmentURL;
                                        applicationCheckListObj.AttachmentURL = response.data.AttachmentURL;
                                        applicationCheckListObj.MimeType = response.data.MimeType;
                                        dynamicFormService.applicationData.TmxLoanApplicationChecklist = vm.resource.TmxLoanApplicationChecklist;
                                        ToastService.showCustomToast("success", "ECIB attached succesfully.");
                                        $scope.$emit("reloadDocuments", "");
                                        window.open(ecibAttachmentURL, '_blank');
                                    }
                                    else {
                                        ToastService.showCustomToast("error", "Error uploading ECIB. Please try again");
                                    }

                                    $scope.$emit("loadingComplete", "");
                                });

                            }
                            reader.readAsDataURL(res);
                        }
                        else {
                            ToastService.showCustomToast("error", "ECIB File not found. Please try again");
                            $scope.$emit("loadingComplete", "");
                            return;
                        }
                    }).error(function (err) {
                        console.log(err);
                        ToastService.showCustomToast("error", "ECIB File not found. Please try again");
                        $scope.$emit("loadingComplete", "");
                        return;
                    });
                }
                catch (err) {
                    console.log(err);
                    ToastService.showCustomToast("error", "Error uploading ECIB. Please try again");
                    $scope.$emit("loadingComplete", "");
                }
            }

            vm.viewEcib = function () {
                var ecibPDFpath = ENV.ecibURL + vm.resource.TmxCustomerMaster[0].NationalIdentifierValue + '.pdf';
                if (!(vm.resource.TmxCustomerMaster[0].EcibFetchFlag == '1')) {
                    ToastService.showCustomToast('error', 'Please Fetch ECIB first');
                    return;
                }

                if (vm.resource.TmxCustomerMaster[0].NationalIdentifierValue) {
                    if(ecibAttachPdf) {
                        if(!ecibProductChecklistId || ecibProductChecklistId.length == 0) {
                            ToastService.showCustomToast('error', 'ECIB Checklist not found. Please save application once and try again.');
                            return;
                        }
                        attachECIBDoc(ecibPDFpath);
                    }
                    else {
                        window.open(ecibPDFpath, '_blank');
                    }
                }
                else {
                    ToastService.showCustomToast('error', 'CNIC not found');
                }

            }

            vm.viewOldEcib = function () {
                if (vm.resource.TmxCustomerMaster[0].OldNationalIdentifierValue) {
                    window.open(ENV.ecibURL + vm.resource.TmxCustomerMaster[0].OldNationalIdentifierValue + '.pdf', '_blank');
                }
                else {
                    ToastService.showCustomToast('error', 'Old CNIC not found');
                }

            }

            vm.showEcibDialog = function () {
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', 'LoanApplicationService', EcibDialogController],
                    templateUrl: 'app/private/transaction/loan-application/edit/ecib-dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: true, // Only for -xs, -sm breakpoints.
                }).then(function () {

                });

            }

            vm.formatDateOfBirth = function (dateTime) {
                if (dateTime) {
                    //var date= new Date(dateTime + 'Z');
                    var date = new Date(dateTime);
                    var month = date.getUTCMonth() + 1; //months from 1-12
                    var day = date.getUTCDate();
                    var year = date.getUTCFullYear();
                    return day + "/" + month + "/" + year;
                }
                else {
                    return 'N/A';
                }
            }

            vm.goto = function (state) {

                if (angular.isDefined(state)) {
                    $state.searchClear = true;
                    $state.go("private.inbox");
                }
                else {
                    $state.searchClear = true;
                    $state.reload($state.current);
                }
            }

            vm.getStatus = function () {
                var ret_status = STATUS.NEW;
                if (exists(vm.resource) && exists(vm.resource.ApplicationStatusLkp)) {
                    var status = vm.statuses.find(function (item) { return item.LookupId == vm.loanApplicationData.ApplicationStatusLkp });
                    if (exists(status)) {
                        ret_status = status.VisibleValue;
                    }
                }
                return ret_status;
            }

            vm.isNew = function () {
                return vm.getStatus() == STATUS.NEW;
            }

            vm.enableUpdate = function () {
                var status = vm.getStatus();
                return status != "Overdue" && status != "Active" && status != "Approved";
            }

            vm.showFunctionalButton = function () {
                if (vm.resource.Commands && vm.resource.Commands.length > 0) {
                    vm.istabDisabled = false;
                    return true;
                }
                else {
                    vm.istabDisabled = true;
                    return false;
                }
            }

            vm.verifyValidations = function () {

            }

            vm.removeViolatedBizRules = function () {
                vm.bizRulesFailedFields.forEach(function (field) {
                    var bizRuleViolations = field.possibleValidations.all.filter(function (violation) { return violation.name.indexOf("bizRule") > -1; })
                    bizRuleViolations.forEach(function (violation) {
                        field.removeValidationRule(violation.name);
                    });
                });
                vm.bizRulesFailedFields = [];
            }
            vm.replaceUnderscoresWithSpaces = function (value) {
                return value.replace(/_/g, " ");
            }
            //#endregion


            //#region  =========== Child/Dialog Controllers ==================================

            function CommentsDialogController($scope, $mdDialog, $filter, TMX_FINANCE_CONSTANTS, tmxUtility, UsersService, lookupService, ToastService, command, Parameter, Actors, Checklists, ProcessID, ApplicationId, UserId, TenantName) {
                $scope.RejectionReasonList = [];
                $scope.ActionType = null;
                $scope.TenantName = TenantName;
                $scope.RoleActorList = Actors;
                $scope.isCommentMandatory = vm.isCommentMandatory;

                //initializing Lookup types from Tmx Finance Constant
                var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;

                $scope.removeReason = function (index) {
                    $scope.RejectionReasonList.splice(index, 1);
                }

                $scope.addReason = function () {

                    $scope.RejectionReasonList.push(
                        {
                            "Comments": "",
                            "RemarksLkp": 0,
                            "LoanApplicationId": ApplicationId,
                            "ActionType": null,
                            "UserId": UserId
                        });
                }

                $scope.addReason();
                $scope.command = command;
                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.done = function () {
                    $scope.CommentsDialogController.dialogForm.$submitted = true;
                    if (!$scope.CommentsDialogController.dialogForm.$valid) {
                        ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                        $scope.CommentsDialogController.dialogForm.$submitted = false;
                        return;
                    }

                    $scope.RejectionReasonList.forEach(function (item) {
                        item.ActionType = $scope.ActionType;
                    });
                    $scope.responseData = {};
                    $scope.responseData.TmxLoanApplicationRemark = $scope.RejectionReasonList;
                    if (!$scope.ChecklistView && tmxUtility.exists($scope.RoleActorList) && $scope.RoleActorList.length > 0) {
                        $scope.responseData.TmxWorkflowReceivingActor = [];
                        $scope.RoleActorList.forEach(actor => {
                            if (actor.RoleType == 1)
                                $scope.responseData.TmxWorkflowReceivingActor.push({ ActorRole: actor.HiddenValue, ActorId: actor.SelectedUser });
                            else
                                $scope.responseData.TmxWorkflowReceivingActor.push({ ActorType: actor.HiddenValue, ActorId: actor.SelectedUser });
                        });
                    }
                    else if ($scope.ChecklistView && tmxUtility.exists($scope.RoleChecklists) && $scope.RoleChecklists.length > 0) {
                        if (vm.resource.TmxLoanApplicationChecklist && vm.resource.TmxLoanApplicationChecklist.length > 0) {
                            vm.resource.TmxLoanApplicationChecklist.forEach(element => {
                                $scope.RoleChecklists.forEach(chk => {
                                    if (element.LoanApplicationChecklistId == chk.LoanApplicationChecklistId)
                                        element.UserID = chk.SelectedUser;
                                })
                            });
                        }
                        $scope.responseData.TmxWorkflowReceivingActor = [];
                        $scope.responseData.TmxWorkflowReceivingActor.push({ ActorRole: $scope.RoleChecklists[0].RoleActorList[0].HiddenValue, ActorId: $scope.RoleChecklists[0].SelectedUser });

                    }
                    $mdDialog.hide($scope.responseData);
                };

                function InitializeLookups() {
                    $scope.lookups = {};
                    lookupService.getLookupByType(lkupType.RejectionTypes).then(function (response) {
                        $scope.lookups.rejectionReasonLkp = response;
                    });

                    lookupService.getLookupByType(lkupType.CIU_REJECTION_CODES).then(function (response) {
                        $scope.lookups.rejectionCodesLkp = response;
                    });
                    lookupService.getLookupByType(lkupType.YES_NO).then(function (response) {
                        $scope.lookups.yesNoLkp = response;
                    });
                }

                function PopulateRoleUserList() {
                    $scope.RoleActorList = [];
                    $scope.RoleChecklists = [];
                    if (tmxUtility.exists(Actors) && Actors.length > 0) {
                        if (Actors.filter(x => x.IsFillVerificationUserInChecklist == 1).length) {
                            $scope.ChecklistView = true;
                            if (tmxUtility.exists(Checklists) && Checklists.length > 0) {
                                var roleNames = Actors.map(x => x.ActorRole);
                                let roleNamesString = roleNames.join(',');
                                UsersService.getUserByRoleNames(roleNamesString, vm.loanApplicationData.CompanyBranchId).then(function (response) {

                                    if (tmxUtility.exists(response, "status.code") || response.status.code == 200) {
                                        roleNames.forEach(name => {
                                            let roleListItem = { HiddenValue: name, VisibleValue: name, RoleType: 1 };
                                            roleListItem.UserList = response.data.filter(x => x.RoleName == name);
                                            $scope.RoleActorList.push(roleListItem);
                                            Checklists.forEach(item => {
                                                var tempChecklist = {};
                                                tempChecklist.RoleActorList = $scope.RoleActorList;
                                                tempChecklist.LoanApplicationChecklistId = item.LoanApplicationChecklistId;
                                                tempChecklist.ChecklistName = item.TmxProductChecklist.CheckListItemName;
                                                var locations = lookupService.getLocalLookupsByType('LOCATION');
                                                if (locations) {
                                                    tempChecklist.LocationName = locations.filter(y => y.LookupId == item.LocationID)[0].VisibleValue;
                                                }
                                                $scope.RoleChecklists.push(tempChecklist);
                                            });
                                        });
                                    }
                                    else {
                                        ToastService.showCustomToast('error', 'Error in getting the users list.')
                                        console.log("Error in fetching user list. Response received: ", response);
                                    }
                                });
                            }
                        }
                        else {
                            $scope.ChecklistView = false;
                            if (Actors.filter(x => x.IsActorRoleType == 1).length > 0) {
                                var roleNames = Actors.map(x => x.ActorRole);
                                let roleNamesString = roleNames.join(',');
                                UsersService.getUserByRoleNames(roleNamesString, vm.loanApplicationData.CompanyBranchId).then(function (response) {

                                    if (tmxUtility.exists(response, "status.code") || response.status.code == 200) {
                                        roleNames.forEach(name => {
                                            let roleListItem = { HiddenValue: name, VisibleValue: name, RoleType: 1 };
                                            roleListItem.UserList = response.data.filter(x => x.RoleName == name);
                                            $scope.RoleActorList.push(roleListItem);
                                        });
                                    }
                                    else {
                                        ToastService.showCustomToast('error', 'Error in getting the users list.')
                                        console.log("Error in fetching user list. Response received: ", response);
                                    }
                                });
                            }
                            if (Actors.filter(x => x.IsActorRoleType == 0).length) {
                                var userTypes = Actors.map(x => x.ActorType);
                                if (userTypes) {
                                    userTypes.forEach(element => {
                                        UsersService.getUsersByType(element).then(function (response) {
                                            var data = lookupService.getLocalLookupsByType('USER');
                                            let users = {};
                                            if (data) {
                                                users.VisibleValue = data.filter(y => y.LookupId == element)[0].VisibleValue;
                                                users.HiddenValue = element;
                                                users.RoleType = 0;
                                            }

                                            users.UserList = response.data;
                                            $scope.RoleActorList.push(users);
                                        })
                                    });
                                }
                            }
                        }
                    }

                }


                (function InitializeDialogController() {
                    InitializeLookups();
                    PopulateRoleUserList();
                })();

            }

            function ManualDeviationDialogController($scope, $mdDialog, $filter, lookupService, UsersService) {
                $scope.UsersList = [];
                $scope.LevelsList = [];
                $scope.isCommentMandatory = vm.isCommentMandatory;
                var data = {};

                lookupService.getByType('USER').then(function (data) {
                    $scope.LevelsList = data;
                });
                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.done = function () {
                    $scope.ManualDeviationDialogController.dialogForm.$submitted = true;
                    if (!$scope.ManualDeviationDialogController.dialogForm.$valid) {
                        ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                        $scope.ManualDeviationDialogController.dialogForm.$submitted = false;
                        return;
                    }
                    if ($scope.userId) {
                        data.userId = $scope.userId;
                        data.comments = $scope.comments;
                        $mdDialog.hide(data);
                    }
                };

                $scope.levelChange = function (typeId) {
                    if (typeId) {
                        UsersService.getUsersByType(typeId).then(function (response) {
                            $scope.UsersList = response.data;

                        })
                    }
                    else {
                        $scope.userId = null;
                        $scope.UsersList = [];
                    }
                }
            }

            function EvaluationRulesDialogController($scope, $mdDialog, $filter, evaluationData, lookupService, UsersService, showOnlyMessages, tenantName, TenantsList) {

                $scope.vm = {};
                $scope.RulesList = [];
                $scope.showDeviationFields = false;
                $scope.showOnlyMessages = showOnlyMessages;
                $scope.TmxLoanApplicationRemark = [{
                    "Comments": ""
                }];
                $scope.isCommentMandatory = vm.isCommentMandatory;

                if (evaluationData.data && evaluationData.data != null) {
                    for (var key in evaluationData.data) {
                        $scope.RulesList.push({
                            ruleKey: key.toUpperCase(),
                            ruleText: evaluationData.data[key]
                        });
                    }
                    if (evaluationData.data.manualDeviation || (evaluationData.data.warning && evaluationData.data.manualDeviation) || (evaluationData.data.error && evaluationData.data.manualDeviation)) {
                        $scope.showDeviationFields = true;
                    }
                    else if (evaluationData.data.error || evaluationData.data.warning || (evaluationData.data.error && evaluationData.data.warning)) {
                        $scope.showDeviationFields = false;
                    }
                }
                else {
                    if (evaluationData.manualDeviation || evaluationData.warning || evaluationData.error) {
                        Object.keys(evaluationData).forEach(function (key) {
                            $scope.RulesList.push({
                                ruleKey: key.toUpperCase(),
                                ruleText: evaluationData[key]
                            });
                        });
                        if (evaluationData.manualDeviation || (evaluationData.warning && evaluationData.manualDeviation) || (evaluationData.error && evaluationData.manualDeviation)) {
                            $scope.showDeviationFields = true;
                        }
                        else if (evaluationData.error || evaluationData.warning || (evaluationData.error && evaluationData.warning)) {
                            $scope.showDeviationFields = false;
                            if (evaluationData.error)
                                vm.status = "error";
                            else if (evaluationData.warning)
                                vm.status = "warning";
                        }
                    }
                }

                $scope.ok = function () {
                    $mdDialog.hide();
                    if (vm.status == "warning" && !$scope.showOnlyMessages)
                        $state.go("private.inbox");
                };


                function getPropertyValueByHiddenValue(levelsList, hiddenValue, property) {
                    var obj = levelsList.filter(function (item) {
                        return item.HiddenValue == hiddenValue;
                    })[0]
                    return obj[property];
                }

                lookupService.getByType('USER').then(function (data) {
                    $scope.LevelsList = data;
                    $scope.disableLevelList = false;
                    if (TenantsList.SILK == tenantName) {
                        var deviationReceivedLevels = [];
                        var obj = $scope.RulesList.filter(function (item) {
                            return item.ruleKey == 'MANUALDEVIATION'
                        })[0];

                        if (obj && obj.ruleText) {
                            obj.ruleText.forEach(function (item) {
                                deviationReceivedLevels.push(
                                    {
                                        name: item.split(':')[0],
                                        id: getPropertyValueByHiddenValue($scope.LevelsList, item.split(':')[0], 'LookupId'),
                                        sort: getPropertyValueByHiddenValue($scope.LevelsList, item.split(':')[0], 'SortOrder')
                                    }
                                )
                            })

                            if (deviationReceivedLevels.length > 0) {
                                deviationReceivedLevels.sort(function (a, b) { return a.sort - b.sort; });
                                $scope.vm.levelId = deviationReceivedLevels[0] ? deviationReceivedLevels[0].id : null;
                                $scope.levelChange($scope.vm.levelId);
                                $scope.disableLevelList = true;
                            }
                        }
                    }
                });

                $scope.levelChange = function (typeId) {
                    if (typeId) {
                        UsersService.getUsersByType(typeId).then(function (response) {
                            $scope.UsersList = response.data;

                        })
                    }
                    else {
                        $scope.vm.userId = null;
                        $scope.UsersList = [];
                    }
                }

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.done = function () {
                    $scope.EvaluationRulesDialogController.dialogForm.$submitted = true;
                    if (!$scope.EvaluationRulesDialogController.dialogForm.$valid) {
                        ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                        $scope.EvaluationRulesDialogController.dialogForm.$submitted = false;
                        return;
                    }
                    if ($scope.vm.userId) {
                        var responseData = {};
                        responseData.TmxLoanApplicationRemark = $scope.TmxLoanApplicationRemark;
                        responseData.TargetUserId = $scope.vm.userId;
                        $mdDialog.hide(responseData);
                    }

                }
            }

            function EcibDialogController($scope, $mdDialog, LoanApplicationService) {
                $scope.bankId = 2;
                $scope.bankNames = [];
                LoanApplicationService.getEcibDetail().then(function (response) {
                    $scope.ecibData = response.data.DBRData;
                    if ($scope.ecibData[0]) {
                        $scope.ecibData[0].BankList.forEach(function (item, index) {
                            $scope.bankNames.push({
                                'VisibleValue': item,
                                'LookupId': index + 1
                            });
                        });
                    }

                });

                $scope.addMoreEcib = function () {
                    $scope.ecibData.push({
                        "MRDate": "",
                        "FDate": "",
                        "DBR": 0,
                        "AsOfDate": "",
                        "Balance": 0,
                        "Limit": 0,
                        "Product": $scope.ecibData.length,
                        "IsDefaulter": false,
                        "TermLoanOrEvergreen": "",
                        "TypeOfLoan": "",
                        "Base64PdfString": null,
                        "Bank": null,
                        "ProductName": ""
                    })
                }

                $scope.removeEcib = function (index) {
                    $scope.ecibData.splice(index);
                }

                $scope.branchChange = function () {
                }

                $scope.pdfUrl = "https://tlxfinance.blob.core.windows.net/images-qa/techx/3520268380749.pdf";

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.formatDate = function (date) {
                    if (date) {
                        var d = new Date(date),
                            month = '' + (d.getMonth() + 1),
                            day = '' + d.getDate(),
                            year = d.getFullYear();

                        if (month.length < 2) month = '0' + month;
                        if (day.length < 2) day = '0' + day;

                        return [year, month, day].join('-');
                    }
                    else {
                        return "";
                    }

                }

            }

            function ControlledDeviationDialogContoller($scope, $mdDialog, $filter, lookupService, UsersService,tmxUtility, deviationData, commandList) {
                $scope.UsersList = [];
                $scope.LevelsList = [];
                $scope.commands = [];
                $scope.commandsDisable = false;
                $scope.vm = {}
                $scope.isCommentMandatory ;//= vm.isCommentMandatory;
                var data = {};
                var commandData;

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.done = function () {
                    $scope.ControlledDeviationDialogController.dialogForm.$submitted = true;
                    if (!$scope.ControlledDeviationDialogController.dialogForm.$valid) {
                        ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                        $scope.ControlledDeviationDialogController.dialogForm.$submitted = false;
                        return;
                    }
                    if ($scope.vm.userId) {
                        data.TmxWorkflowReceivingActor= [];
                        if(tmxUtility.exists(commandData,'TmxWorkflowReceivingActor')){
                            commandData.TmxWorkflowReceivingActor.forEach(x=>{
                                if(x.IsActorRoleType == 0){
                                    data.TmxWorkflowReceivingActor.push({ ActorType: $scope.vm.levelId, ActorId: $scope.vm.userId });
                                    
                                }
                                else{
                                    data.TmxWorkflowReceivingActor.push({ ActorRole: $scope.vm.roleId, ActorId: $scope.vm.userId });
                                }
                            });
                        }
                        data.commandName = $scope.vm.selectedCommand || 'DeviationApproval'
                        data.targetUserId = $scope.vm.userId;
                        data.comments = $scope.vm.comments;
                        $mdDialog.hide(data);
                        
                    }
                };

                $scope.levelChange = function (typeId) {
                    if (typeId) {
                        UsersService.getUsersByType(typeId).then(function (response) {
                            $scope.UsersList = response.data;

                        })
                    }
                    else {
                        $scope.userId = null;
                        $scope.UsersList = [];
                    }
                };

                $scope.onCommandChange = function(command){
                    commandData = $scope.commands.find(x=>x.HiddenValue == command);
                    if(tmxUtility.exists(commandData, 'TmxWorkflowReceivingActor')){
                        let receivingActorWithType = commandData.TmxWorkflowReceivingActor.find(x=>tmxUtility.exists(x.ActorType));
                        $scope.vm.levelId = receivingActorWithType.ActorType;
                        $scope.levelChange($scope.vm.levelId);
                    }
                }

                function SetDefaultData() {
                    if (tmxUtility.exists(commandList)) {
                        $scope.commands = commandList.filter(x => x.IsDeviation == 1);
                    }
                    if($scope.commands.length == 1){
                        $scope.commandsDisable = true;
                        $scope.vm.selectedCommand = $scope.commands[0].HiddenValue;
                        $scope.onCommandChange($scope.vm.selectedCommand);
                    }
                }

                (function InitializeDialog() {
                    lookupService.getByType('USER').then(function (data) {
                        $scope.LevelsList = data;
                    });
                    SetDefaultData();
                })()
            }

            //#endregion


            //#region  =========== Publishers and Subscribers==================================

            $scope.$on("SelectChangeEvent", function (event, form_name) {

                if (vitasTenants.includes(tenantName) && tmxUtility.checkPermission('Validate Service', 'View') && !vm.hideValidateButton) {
                    vm.disableActionButton1 = true;
                    vm.disableActionButton2 = true;
                }
                else if (TenantsList.SAMBA == tenantName && tmxUtility.checkPermission('Validate Service', 'View')) {
                    vm.disableActionButton1 = true;
                }
                else if (TenantsList.SILK == tenantName && form_name == "slsForm") {
                    $scope.$emit("reloadApplicationData", "");
                }
            });

            $scope.$on("reloadApplicationData", function () {

                vm.slsUpdated = true;
            });
            $scope.$on("reloadECIBData", function () {
                vm.ecibUpdated = true;
            });
            $scope.$on("reloadECIB", function () {
                vm.silkECIBUpdated = true;
            });
            $scope.$on("reloadDocuments", function (val) {
                vm.reloadDocuments = true;
                if(!vm.ResourceCopy) {
                    vm.ResourceCopy = vm.resource;
                }
                vm.ResourceCopy.TmxLoanApplicationChecklist= dynamicFormService.applicationData.TmxLoanApplicationChecklist;
                loadData(vm.ResourceCopy);
            });
            $scope.$on("loading", function (val) {
                vm.isPageLoading = true;
            });
            $scope.$on("loadingComplete", function (val) {
                vm.isPageLoading = false;
            });

            BroadcastService.subscribe("onGridDataFetch", $scope, function (evt, data) {

                vm.isPageLoading = true;
                var sourceTable = dynamicFormService.mapArray[data.src].table;
                var destinationTable = data.des;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.page.write(vm.ResourceCopy, false);
                unwrapLoanApplicationAttributes(vm.ResourceCopy);
                vm.mapresource();
                vm.bindRootObjectsToChildObjects();
                makeArrayToObject(vm.ResourceCopy);
                vm.deleteEmptyObjects();
                objectCleaning(vm.ResourceCopy);
                setLoanApplicationChecklist();
                eval('vm.ResourceCopy.' + destinationTable + ' = vm.ResourceCopy.' + sourceTable);
                loadData(vm.ResourceCopy);
                vm.isPageLoading = false;

            });

            BroadcastService.subscribe('reloadGuarantorData', $scope, function () {
                vm.resource['TmxLoanApplicationToGuarantorMappingDummy[0].TmxGuarantor'] = dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMappingDummy[0].TmxGuarantor;
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                formatJsonForPost();
                loadData(vm.resource);
            });

            BroadcastService.subscribe('updateGuarantorData', $scope, function () {
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, false);
                formatJsonForPost();
                vm.resource = vm.ResourceCopy;
                dynamicFormService.applicationData = vm.resource;
                $rootScope.selectedTabId = 239;
                loadData(vm.resource);
            });

            BroadcastService.subscribe('addGuarantorData', $scope, function () {
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                vm.page.write(vm.ResourceCopy, false);

                dynamicFormService.applicationGuarantorMappingData.push(
                    {
                        TmxGuarantor: vm.ResourceCopy['TmxLoanApplicationToGuarantorMappingDummy[0].TmxGuarantor']
                    }
                )
            });
            BroadcastService.subscribe('reloadCustomerData', $scope, function () {
                vm.isPageLoading = true;
                vm.resource.TmxCustomerMaster[0].IdentifierLkpValue = dynamicFormService.applicationData.TmxCustomerMaster[0].NationalIdTypeLkp;
                vm.resource.TmxCustomerMaster[0].NationalIdentifierValue = dynamicFormService.applicationData.TmxCustomerMaster[0].NationalIdentifierValue;
                vm.resource.TmxCustomerMaster[0].CustomerCode = dynamicFormService.applicationData.TmxCustomerMaster[0].CustomerCode;
                vm.resource.TmxCustomerMaster[0].TmxCustomerExistingLoan = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxCustomerExistingLoan;
                vm.resource.TmxCustomerMaster[0].ETBFetchFlag = dynamicFormService.applicationData.TmxCustomerMaster[0].ETBFetchFlag;
                //vm.resource.TmxCustomerMaster[0] = dynamicFormService.applicationData.TmxCustomerMaster[0];
                vm.ResourceCopy = angular.copy(vm.resource);
                vm.LoanApplicationDataCopy = angular.copy(vm.loanApplicationData);
                formatJsonForPost();
                loadData(vm.resource);
                vm.isPageLoading = false;
            });
            BroadcastService.subscribe('reloadBVSData', $scope, function () {
                vm.checklistUpdated = true;
                vm.resource.TmxCustomerMaster[0].isNadraVerified = dynamicFormService.applicationData.TmxCustomerMaster[0].isNadraVerified;
            });


            //#endregion


            //#region ============ Page Initialization============================================

            (function InitializePage() {
                readConfigurations();
                setDataAndState()
                tenantWiseLogic();
                setStatusBasedVariables();
                setButtonsVisiblity();
                setupActionButtons();
            })();

            //#endregion


        }]);
})();
